import React, { useContext, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../../Styles/globalStyle.css";
import useAxiosOperation from "../../../Hooks/useAxiosOperation.js";
import SpinnerIcon from "../../Commands/SpinnerIcon/SpinnerIcon.js";
import DropDownListNew from "../../DropDownList/DropDownListNew";
import FormSettings from "../../Settings/FormSettings/FormSettings";
import uuid from "react-native-uuid";
import { store } from "../../../store.js";
import SaveCommand from "../../Commands/SaveCommand/SaveCommand";
import AddCommand from "../../Commands/AddCommand/AddCommand";
import CloseCommand from "../../Commands/CloseCommand/CloseCommand";
import useGetCurrentsTools from "../../../Hooks/useGetCurrentsTools.js";
import SimpleDialog from "../../SimpleDialog/SimpleDialog";

export default function User(props) {
  const axiosOperation = useAxiosOperation();
  const globalState = useContext(store);
  const { dispatch } = globalState;
  const getCurrentsTools = useGetCurrentsTools();
  const firstNameId = 2;
  const lastNameId = 3;
  const emailId = 4;
  const headerFirstNameId = 15;
  const headerLastNameId = 19;
  const headerEmailId = 27;
  const [loaded, setLoaded] = useState(true);
  const formData ={ currentMaxId:29 , metaData :[
    {
      "id":1,
      "parentId":[],
      "parentGlobalId":[],
      "order":1,
      "type":"Form",
      "properties":{
         "name":{
            "value":"Form",
            "control":"TextBox"
         },
         "text":{
            "value":"Form",
            "control":"TextBox"
         },
         "actions":{
            "value":"",
            "control":"TextBox",
         },
         "actualize":{
            "value":true,
            "control":"TextBox",
            "hide":true
         }
      },
      "policy":{
         "read":true,
         "edit":true,
         "delete":true
      },
      "metaData":[
         {
            "id":2,
            "order":2,
            "type":"TextBox",
            "properties":{
               "name":{
                  "value":"FirstName",
                  "control":"TextBox"
               },
               "field":{
                  "value":"First Name",
                  "control":"TextBox"
               },
               "text":{
                  "value":"",
                  "control":"TextBox"
               },
               "actions":{
                  "value":"",
                  "control":"TextBox"
               },
               "readOnly":{
                  "value":false,
                  "control":"CheckBox"
               },
               "placeholder":{
                  "value":"First Name",
                  "control":"TextBox"
               },
               "toolTip":{
                  "value":true,
                  "control":"CheckBox"
               },
               "toolTipText":{
                  "value":"",
                  "control":"TextBox"
               },
               "maxLength":{
                  "value":200,
                  "control":"TextBox"
               },
               "type":{
                  "value":"String",
                  "control":"ListBox",
                  "values":[
                     {
                        "id":"0",
                        "item":"String",
                        "value":"String"
                     },
                     {
                        "id":"1",
                        "item":"Integer",
                        "value":"Integer"
                     },
                     {
                        "id":"2",
                        "item":"Decimal",
                        "value":"Decimal"
                     }
                  ]
               },
               "masks":{
                  "value":"",
                  "control":"TextBox",
                  "maskValue":""
               },
               "validations":{
                  "value":"REQUIRE",
                  "control":"ListBoxCheckBox",
                  "selectedValues":[
                     {
                        "id":"1",
                        "type":"REQUIRE",
                        "events":[
                           "onBlur",
                           "onSubmit"
                        ]
                     }
                  ],
                  "values":[
                     {
                        "id":"1",
                        "item":"REQUIRE",
                        "value":{
                           "id":"1",
                           "type":"REQUIRE",
                           "events":[
                              "onBlur",
                              "onSubmit"
                           ]
                        }
                     },
                     {
                        "id":"2",
                        "item":"NUMBER",
                        "value":{
                           "id":"2",
                           "type":"NUMBER",
                           "events":[
                              "onChange",
                              "onkeyPress"
                           ]
                        }
                     },
                     {
                        "id":"3",
                        "item":"EMAIL",
                        "value":{
                           "id":"3",
                           "type":"EMAIL",
                           "events":[
                              "onBlur"
                           ]
                        }
                     },
                     {
                        "id":"4",
                        "item":"UNIQUE",
                        "value":{
                           "id":"4",
                           "type":"UNIQUE",
                           "events":[
                              "onBlur"
                           ]
                        }
                     },
                     {
                        "id":"5",
                        "item":"NOSPACE",
                        "value":{
                           "id":"5",
                           "type":"NOSPACE",
                           "events":[
                              "onkeyPress"
                           ]
                        }
                     },
                     {
                        "id":"6",
                        "item":"NOSPECIALCHAR",
                        "value":{
                           "id":"6",
                           "type":"NOSPECIALCHAR",
                           "events":[
                              "onkeyPress"
                           ]
                        }
                     },
                     {
                        "id":"7",
                        "item":"PATTERN",
                        "value":{
                           "id":"7",
                           "type":"PATTERN",
                           "events":[
                              "onBlur"
                           ]
                        }
                     }
                  ]
               },
               "operators":{
                  "value":"",
                  "control":"ListBoxCheckBox",
                  "selectedValues":[
                     
                  ],
                  "values":[
                     {
                        "id":"1",
                        "item":"equal",
                        "value":{
                           "id":"1",
                           "type":"equal"
                        }
                     },
                     {
                        "id":"2",
                        "item":"not equal",
                        "value":{
                           "id":"2",
                           "type":"not equal"
                        }
                     },
                     {
                        "id":"3",
                        "item":"greater",
                        "value":{
                           "id":"3",
                           "type":"greater"
                        }
                     },
                     {
                        "id":"4",
                        "item":"greater & equal",
                        "value":{
                           "id":"4",
                           "type":"greater & equal"
                        }
                     },
                     {
                        "id":"5",
                        "item":"lower",
                        "value":{
                           "id":"5",
                           "type":"lower"
                        }
                     },
                     {
                        "id":"6",
                        "item":"lower & equal",
                        "value":{
                           "id":"6",
                           "type":"lower & equal"
                        }
                     },
                     {
                        "id":"7",
                        "item":"contains",
                        "value":{
                           "id":"7",
                           "type":"contains"
                        }
                     },
                     {
                        "id":"8",
                        "item":"starts with",
                        "value":{
                           "id":"8",
                           "type":"starts with"
                        }
                     },
                     {
                        "id":"9",
                        "item":"ends with",
                        "value":{
                           "id":"9",
                           "type":"ends with"
                        }
                     }
                  ]
               },
               "prefix":{
                  "value":"",
                  "control":"TextBox"
               },
               "suffix":{
                  "value":"",
                  "control":"TextBox"
               },
               "wholeNumberLength":{
                  "value":10,
                  "control":"TextBox"
               },
               "decimalSize":{
                  "value":2,
                  "control":"TextBox"
               },
               "decimalSeparator":{
                  "value":"",
                  "control":"TextBox"
               },
               "groupSize":{
                  "value":3,
                  "control":"TextBox"
               },
               "groupSeparator":{
                  "value":"",
                  "control":"TextBox"
               },
               "index":{
                  "value":false,
                  "control":"CheckBox"
               }
            },
            "policy":{
               "read":true,
               "edit":true,
               "delete":true
            },
            "styles":{
               "fontSize":{
                  "value":"14px"
               },
               "fontFamily":{
                  "value":"Arial"
               },
               "color":{
                  "value":"#212121"
               },
               "left":{
                  "value":7.5,
                  "hide":true
               },
               "top":{
                  "value":17,
                  "hide":true
               },
               "width":{
                  "value":"259px",
                  "hide":true
               },
               "display":{
                  "value":"flex",
                  "hide":true
               },
               "height":{
                  "value":"28px",
                  "hide":true
               },
               "visibility":{
                  "value":"visible"
               },
               "borderLeft":{
                  "value":"1px solid #cccccc"
               },
               "borderTop":{
                  "value":"1px solid #cccccc"
               },
               "borderTopLeftRadius":{
                  "value":"2px"
               },
               "borderTopRightRadius":{
                  "value":"2px"
               },
               "borderRight":{
                  "value":"1px solid #cccccc"
               },
               "borderBottom":{
                  "value":"1px solid #cccccc"
               },
               "borderBottomLeftRadius":{
                  "value":"2px"
               },
               "borderBottomRightRadius":{
                  "value":"2px"
               },
               "background":{
                  "value":"white"
               },
               "boxSizing":{
                  "value":"border-box",
                  "hide":true
               },
               "textAlign":{
                  "value":"left"
               },
               "resize":{
                  "value":"both",
                  "hide":true
               },
               "overflow":{
                  "value":"auto",
                  "hide":true
               }
            },
            "parentId":[
               1
            ],
            "left":{
               "value":7.5
            },
            "top":{
               "value":17
            },
            "globalId":"47ad3122-4ca6-4b24-b572-79eac6548b57",
            "parentGlobalId":[
               "4b0bd589-f5a3-4360-9dba-9ecec09b8ea1"
            ]
         },
         {
            "id":3,
            "order":2,
            "type":"TextBox",
            "properties":{
               "name":{
                  "value":"LastName",
                  "control":"TextBox"
               },
               "field":{
                  "value":"Last Name",
                  "control":"TextBox"
               },
               "text":{
                  "value":"",
                  "control":"TextBox"
               },
               "actions":{
                  "value":"",
                  "control":"TextBox"
               },
               "readOnly":{
                  "value":false,
                  "control":"CheckBox"
               },
               "placeholder":{
                  "value":"Last Name",
                  "control":"TextBox"
               },
               "toolTip":{
                  "value":true,
                  "control":"CheckBox"
               },
               "toolTipText":{
                  "value":"",
                  "control":"TextBox"
               },
               "maxLength":{
                  "value":200,
                  "control":"TextBox"
               },
               "type":{
                  "value":"String",
                  "control":"ListBox",
                  "values":[
                     {
                        "id":"0",
                        "item":"String",
                        "value":"String"
                     },
                     {
                        "id":"1",
                        "item":"Integer",
                        "value":"Integer"
                     },
                     {
                        "id":"2",
                        "item":"Decimal",
                        "value":"Decimal"
                     }
                  ]
               },
               "masks":{
                  "value":"",
                  "control":"TextBox",
                  "maskValue":""
               },
               "validations":{
                  "value":"REQUIRE",
                  "control":"ListBoxCheckBox",
                  "selectedValues":[
                     {
                        "id":"1",
                        "type":"REQUIRE",
                        "events":[
                           "onBlur",
                           "onSubmit"
                        ]
                     }
                  ],
                  "values":[
                     {
                        "id":"1",
                        "item":"REQUIRE",
                        "value":{
                           "id":"1",
                           "type":"REQUIRE",
                           "events":[
                              "onBlur",
                              "onSubmit"
                           ]
                        }
                     },
                     {
                        "id":"2",
                        "item":"NUMBER",
                        "value":{
                           "id":"2",
                           "type":"NUMBER",
                           "events":[
                              "onChange",
                              "onkeyPress"
                           ]
                        }
                     },
                     {
                        "id":"3",
                        "item":"EMAIL",
                        "value":{
                           "id":"3",
                           "type":"EMAIL",
                           "events":[
                              "onBlur"
                           ]
                        }
                     },
                     {
                        "id":"4",
                        "item":"UNIQUE",
                        "value":{
                           "id":"4",
                           "type":"UNIQUE",
                           "events":[
                              "onBlur"
                           ]
                        }
                     },
                     {
                        "id":"5",
                        "item":"NOSPACE",
                        "value":{
                           "id":"5",
                           "type":"NOSPACE",
                           "events":[
                              "onkeyPress"
                           ]
                        }
                     },
                     {
                        "id":"6",
                        "item":"NOSPECIALCHAR",
                        "value":{
                           "id":"6",
                           "type":"NOSPECIALCHAR",
                           "events":[
                              "onkeyPress"
                           ]
                        }
                     },
                     {
                        "id":"7",
                        "item":"PATTERN",
                        "value":{
                           "id":"7",
                           "type":"PATTERN",
                           "events":[
                              "onBlur"
                           ]
                        }
                     }
                  ]
               },
               "operators":{
                  "value":"",
                  "control":"ListBoxCheckBox",
                  "selectedValues":[
                     
                  ],
                  "values":[
                     {
                        "id":"1",
                        "item":"equal",
                        "value":{
                           "id":"1",
                           "type":"equal"
                        }
                     },
                     {
                        "id":"2",
                        "item":"not equal",
                        "value":{
                           "id":"2",
                           "type":"not equal"
                        }
                     },
                     {
                        "id":"3",
                        "item":"greater",
                        "value":{
                           "id":"3",
                           "type":"greater"
                        }
                     },
                     {
                        "id":"4",
                        "item":"greater & equal",
                        "value":{
                           "id":"4",
                           "type":"greater & equal"
                        }
                     },
                     {
                        "id":"5",
                        "item":"lower",
                        "value":{
                           "id":"5",
                           "type":"lower"
                        }
                     },
                     {
                        "id":"6",
                        "item":"lower & equal",
                        "value":{
                           "id":"6",
                           "type":"lower & equal"
                        }
                     },
                     {
                        "id":"7",
                        "item":"contains",
                        "value":{
                           "id":"7",
                           "type":"contains"
                        }
                     },
                     {
                        "id":"8",
                        "item":"starts with",
                        "value":{
                           "id":"8",
                           "type":"starts with"
                        }
                     },
                     {
                        "id":"9",
                        "item":"ends with",
                        "value":{
                           "id":"9",
                           "type":"ends with"
                        }
                     }
                  ]
               },
               "prefix":{
                  "value":"",
                  "control":"TextBox"
               },
               "suffix":{
                  "value":"",
                  "control":"TextBox"
               },
               "wholeNumberLength":{
                  "value":10,
                  "control":"TextBox"
               },
               "decimalSize":{
                  "value":2,
                  "control":"TextBox"
               },
               "decimalSeparator":{
                  "value":"",
                  "control":"TextBox"
               },
               "groupSize":{
                  "value":3,
                  "control":"TextBox"
               },
               "groupSeparator":{
                  "value":"",
                  "control":"TextBox"
               },
               "index":{
                  "value":false,
                  "control":"CheckBox"
               }
            },
            "policy":{
               "read":true,
               "edit":true,
               "delete":true
            },
            "styles":{
               "fontSize":{
                  "value":"14px"
               },
               "fontFamily":{
                  "value":"Arial"
               },
               "color":{
                  "value":"#212121"
               },
               "left":{
                  "value":280.5,
                  "hide":true
               },
               "top":{
                  "value":17,
                  "hide":true
               },
               "width":{
                  "value":"257px",
                  "hide":true
               },
               "display":{
                  "value":"flex",
                  "hide":true
               },
               "height":{
                  "value":"28px",
                  "hide":true
               },
               "visibility":{
                  "value":"visible"
               },
               "borderLeft":{
                  "value":"1px solid #cccccc"
               },
               "borderTop":{
                  "value":"1px solid #cccccc"
               },
               "borderTopLeftRadius":{
                  "value":"2px"
               },
               "borderTopRightRadius":{
                  "value":"2px"
               },
               "borderRight":{
                  "value":"1px solid #cccccc"
               },
               "borderBottom":{
                  "value":"1px solid #cccccc"
               },
               "borderBottomLeftRadius":{
                  "value":"2px"
               },
               "borderBottomRightRadius":{
                  "value":"2px"
               },
               "background":{
                  "value":"white"
               },
               "boxSizing":{
                  "value":"border-box",
                  "hide":true
               },
               "textAlign":{
                  "value":"left"
               },
               "resize":{
                  "value":"both",
                  "hide":true
               },
               "overflow":{
                  "value":"auto",
                  "hide":true
               }
            },
            "parentId":[
               1
            ],
            "left":{
               "value":284.5
            },
            "top":{
               "value":18
            },
            "globalId":"e405ef30-c5cf-41c6-8e3d-2460401786a2",
            "parentGlobalId":[
               "4b0bd589-f5a3-4360-9dba-9ecec09b8ea1"
            ]
         },
         {
            "id":4,
            "order":2,
            "type":"TextBox",
            "properties":{
               "name":{
                  "value":"Email",
                  "control":"TextBox"
               },
               "field":{
                  "value":"Email",
                  "control":"TextBox"
               },
               "text":{
                  "value":"",
                  "control":"TextBox"
               },
               "actions":{
                  "value":"",
                  "control":"TextBox"
               },
               "readOnly":{
                  "value":false,
                  "control":"CheckBox"
               },
               "placeholder":{
                  "value":"Email",
                  "control":"TextBox"
               },
               "toolTip":{
                  "value":true,
                  "control":"CheckBox"
               },
               "toolTipText":{
                  "value":"",
                  "control":"TextBox"
               },
               "maxLength":{
                  "value":200,
                  "control":"TextBox"
               },
               "type":{
                  "value":"String",
                  "control":"ListBox",
                  "values":[
                     {
                        "id":"0",
                        "item":"String",
                        "value":"String"
                     },
                     {
                        "id":"1",
                        "item":"Integer",
                        "value":"Integer"
                     },
                     {
                        "id":"2",
                        "item":"Decimal",
                        "value":"Decimal"
                     }
                  ]
               },
               "masks":{
                  "value":"",
                  "control":"TextBox",
                  "maskValue":""
               },
               "validations":{
                  "value":"Many...",
                  "control":"ListBoxCheckBox",
                  "selectedValues":[
                     {
                        "id":"1",
                        "type":"REQUIRE",
                        "events":[
                           "onBlur",
                           "onSubmit"
                        ]
                     },
                     {
                        "id":"3",
                        "type":"EMAIL",
                        "events":[
                           "onBlur"
                        ]
                     }
                  ],
                  "values":[
                     {
                        "id":"1",
                        "item":"REQUIRE",
                        "value":{
                           "id":"1",
                           "type":"REQUIRE",
                           "events":[
                              "onBlur",
                              "onSubmit"
                           ]
                        }
                     },
                     {
                        "id":"2",
                        "item":"NUMBER",
                        "value":{
                           "id":"2",
                           "type":"NUMBER",
                           "events":[
                              "onChange",
                              "onkeyPress"
                           ]
                        }
                     },
                     {
                        "id":"3",
                        "item":"EMAIL",
                        "value":{
                           "id":"3",
                           "type":"EMAIL",
                           "events":[
                              "onBlur"
                           ]
                        }
                     },
                     {
                        "id":"4",
                        "item":"UNIQUE",
                        "value":{
                           "id":"4",
                           "type":"UNIQUE",
                           "events":[
                              "onBlur"
                           ]
                        }
                     },
                     {
                        "id":"5",
                        "item":"NOSPACE",
                        "value":{
                           "id":"5",
                           "type":"NOSPACE",
                           "events":[
                              "onkeyPress"
                           ]
                        }
                     },
                     {
                        "id":"6",
                        "item":"NOSPECIALCHAR",
                        "value":{
                           "id":"6",
                           "type":"NOSPECIALCHAR",
                           "events":[
                              "onkeyPress"
                           ]
                        }
                     },
                     {
                        "id":"7",
                        "item":"PATTERN",
                        "value":{
                           "id":"7",
                           "type":"PATTERN",
                           "events":[
                              "onBlur"
                           ]
                        }
                     }
                  ]
               },
               "operators":{
                  "value":"",
                  "control":"ListBoxCheckBox",
                  "selectedValues":[
                     
                  ],
                  "values":[
                     {
                        "id":"1",
                        "item":"equal",
                        "value":{
                           "id":"1",
                           "type":"equal"
                        }
                     },
                     {
                        "id":"2",
                        "item":"not equal",
                        "value":{
                           "id":"2",
                           "type":"not equal"
                        }
                     },
                     {
                        "id":"3",
                        "item":"greater",
                        "value":{
                           "id":"3",
                           "type":"greater"
                        }
                     },
                     {
                        "id":"4",
                        "item":"greater & equal",
                        "value":{
                           "id":"4",
                           "type":"greater & equal"
                        }
                     },
                     {
                        "id":"5",
                        "item":"lower",
                        "value":{
                           "id":"5",
                           "type":"lower"
                        }
                     },
                     {
                        "id":"6",
                        "item":"lower & equal",
                        "value":{
                           "id":"6",
                           "type":"lower & equal"
                        }
                     },
                     {
                        "id":"7",
                        "item":"contains",
                        "value":{
                           "id":"7",
                           "type":"contains"
                        }
                     },
                     {
                        "id":"8",
                        "item":"starts with",
                        "value":{
                           "id":"8",
                           "type":"starts with"
                        }
                     },
                     {
                        "id":"9",
                        "item":"ends with",
                        "value":{
                           "id":"9",
                           "type":"ends with"
                        }
                     }
                  ]
               },
               "prefix":{
                  "value":"",
                  "control":"TextBox"
               },
               "suffix":{
                  "value":"",
                  "control":"TextBox"
               },
               "wholeNumberLength":{
                  "value":10,
                  "control":"TextBox"
               },
               "decimalSize":{
                  "value":2,
                  "control":"TextBox"
               },
               "decimalSeparator":{
                  "value":"",
                  "control":"TextBox"
               },
               "groupSize":{
                  "value":3,
                  "control":"TextBox"
               },
               "groupSeparator":{
                  "value":"",
                  "control":"TextBox"
               },
               "index":{
                  "value":false,
                  "control":"CheckBox"
               }
            },
            "policy":{
               "read":true,
               "edit":true,
               "delete":true
            },
            "styles":{
               "fontSize":{
                  "value":"14px"
               },
               "fontFamily":{
                  "value":"Arial"
               },
               "color":{
                  "value":"#212121"
               },
               "left":{
                  "value":551.5,
                  "hide":true
               },
               "top":{
                  "value":17,
                  "hide":true
               },
               "width":{
                  "value":"258px",
                  "hide":true
               },
               "display":{
                  "value":"flex",
                  "hide":true
               },
               "height":{
                  "value":"29px",
                  "hide":true
               },
               "visibility":{
                  "value":"visible"
               },
               "borderLeft":{
                  "value":"1px solid #cccccc"
               },
               "borderTop":{
                  "value":"1px solid #cccccc"
               },
               "borderTopLeftRadius":{
                  "value":"2px"
               },
               "borderTopRightRadius":{
                  "value":"2px"
               },
               "borderRight":{
                  "value":"1px solid #cccccc"
               },
               "borderBottom":{
                  "value":"1px solid #cccccc"
               },
               "borderBottomLeftRadius":{
                  "value":"2px"
               },
               "borderBottomRightRadius":{
                  "value":"2px"
               },
               "background":{
                  "value":"white"
               },
               "boxSizing":{
                  "value":"border-box",
                  "hide":true
               },
               "textAlign":{
                  "value":"left"
               },
               "resize":{
                  "value":"both",
                  "hide":true
               },
               "overflow":{
                  "value":"auto",
                  "hide":true
               }
            },
            "parentId":[
               1
            ],
            "left":{
               "value":552.5
            },
            "top":{
               "value":17
            },
            "globalId":"55137dd6-d3f5-43b4-bc30-ec74352eb18f",
            "parentGlobalId":[
               "4b0bd589-f5a3-4360-9dba-9ecec09b8ea1"
            ]
         },
         {
            "id":5,
            "order":2,
            "currentMaxId":0,
            "type":"DataGrid",
            "selectedValues":[
               15,
               19,
               23,
               27
            ],
            "properties":{
               "name":{
                  "value":"DataGrid5",
                  "control":"TextBox"
               },
               "text":{
                  "value":"DataGrid",
                  "control":"TextBox"
               },
               "sliceStart":{
                  "value":1,
                  "control":"TextBox"
               },
               "sliceSize":{
                  "value":10,
                  "control":"TextBox"
               },
               "size":{
                  "value":0,
                  "control":"TextBox",
                  "hide":true
               },
               "actualize":{
                  "value":0,
                  "control":"TextBox",
                  "hide":true
               },
               "search":{
                  "value":true,
                  "control":"CheckBox"
               },
               "header":{
                  "value":true,
                  "control":"CheckBox"
               },
               "filter":{
                  "value":true,
                  "control":"CheckBox"
               },
               "actions":{
                  "value":"",
                  "control":"TextBox"
               },
               "add":{
                  "value":false,
                  "control":"CheckBox"
               },
               "delete":{
                  "value":false,
                  "control":"CheckBox"
               },
               "data":{
                  "value":{
                     "list":{
                        
                     },
                     "mapping":{
                        "id":0,
                        "maxId":0,
                        "values":[
                           {
                              "id":0,
                              "item":"Loading",
                              "value":[
                                 "12d35cfc-e484-4148-8548-cc8f294b75c3"
                              ],
                              "details":[
                                 {
                                    "id":1,
                                    "option":"Mapping",
                                    "key":{
                                       "id":"Mappingkey1",
                                       "value":[
                                          "55bcafe9-3c5d-49d8-a7a0-f6504879f17e",
                                          "0749f752-a904-49fc-87ef-499d0b1071b4"
                                       ],
                                       "isClick":false
                                    },
                                    "value":{
                                       "id":"Mappingvalue1",
                                       "value":[
                                          "12d35cfc-e484-4148-8548-cc8f294b75c3",
                                          "12d35cfc-e484-4148-8548-cc8f294b75c3_1",
                                          "12d35cfc-e484-4148-8548-cc8f294b75c3_1_1"
                                       ],
                                       "isClick":false
                                    }
                                 },
                                 {
                                    "id":2,
                                    "option":"Mapping",
                                    "key":{
                                       "id":"Mappingkey2",
                                       "value":[
                                          "55bcafe9-3c5d-49d8-a7a0-f6504879f17e",
                                          "e86e9935-b4ca-434a-852f-4c5b9cceae59"
                                       ],
                                       "isClick":false
                                    },
                                    "value":{
                                       "id":"Mappingvalue2",
                                       "value":[
                                          "12d35cfc-e484-4148-8548-cc8f294b75c3",
                                          "12d35cfc-e484-4148-8548-cc8f294b75c3_1",
                                          "12d35cfc-e484-4148-8548-cc8f294b75c3_1_0"
                                       ],
                                       "isClick":false
                                    }
                                 },
                                 {
                                    "id":3,
                                    "option":"Mapping",
                                    "key":{
                                       "id":"Mappingkey3",
                                       "value":[
                                          "55bcafe9-3c5d-49d8-a7a0-f6504879f17e",
                                          "99f5450e-24be-4693-9eaf-ef7ba77adbac"
                                       ],
                                       "isClick":false
                                    },
                                    "value":{
                                       "id":"Mappingvalue3",
                                       "value":[
                                          "12d35cfc-e484-4148-8548-cc8f294b75c3",
                                          "12d35cfc-e484-4148-8548-cc8f294b75c3_1",
                                          "12d35cfc-e484-4148-8548-cc8f294b75c3_1_8"
                                       ],
                                       "isClick":false
                                    }
                                 }
                              ]
                           }
                        ],
                        "isClick":false,
                        "detailsId":3,
                        "maxDetailsId":3
                     },
                     "tree":{
                        "treeDataType":"Form"
                     },
                     "input":{
                        
                     }
                  },
                  "options":[
                     "Mapping"
                  ],
                  "control":"TextBox",
                  "option":"Mapping"
               }
            },
            "metaData":[
               {
                  "id":6,
                  "order":5,
                  "currentMaxId":0,
                  "type":"SearchGrid",
                  "properties":{
                     "name":{
                        "value":"SearchGrid6",
                        "control":"TextBox"
                     },
                     "text":{
                        "value":"SearchGrid",
                        "control":"TextBox"
                     }
                  },
                  "metaData":[
                     
                  ],
                  "policy":{
                     "read":true,
                     "edit":true,
                     "delete":true
                  },
                  "styles":{
                     "fontSize":{
                        "value":"14px"
                     },
                     "fontFamily":{
                        "value":"Arial"
                     },
                     "color":{
                        "value":"#212121"
                     },
                     "backgroundColor":{
                        "value":"#f2f3f5"
                     },
                     "height":{
                        "value":"30px",
                        "hide":true
                     },
                     "width":{
                        "value":"100%",
                        "hide":true
                     },
                     "display":{
                        "value":"flex",
                        "hide":true
                     },
                     "position":{
                        "value":"relative",
                        "hide":true
                     },
                     "boxSizing":{
                        "value":"border-box",
                        "hide":true
                     },
                     "overflow":{
                        "value":"hidden",
                        "hide":true
                     },
                     "border":{
                        "value":"1px solid #cccccc"
                     }
                  },
                  "left":{
                     "value":5
                  },
                  "top":{
                     "value":59
                  },
                  "globalId":"7dd91fa4-4ed9-46f7-9d54-fef66439d369",
                  "parentId":[
                     5,
                     1
                  ],
                  "parentGlobalId":[
                     "55bcafe9-3c5d-49d8-a7a0-f6504879f17e",
                     "4b0bd589-f5a3-4360-9dba-9ecec09b8ea1"
                  ]
               },
               {
                  "id":7,
                  "order":5,
                  "currentMaxId":0,
                  "type":"Header",
                  "properties":{
                     "name":{
                        "value":"Header7",
                        "control":"TextBox"
                     },
                     "text":{
                        "value":"Header",
                        "control":"TextBox"
                     }
                  },
                  "metaData":[
                     {
                        "id":11,
                        "order":2,
                        "type":"TextBox",
                        "properties":{
                           "name":{
                              "value":"TextBox11",
                              "control":"TextBox"
                           },
                           "field":{
                              "value":"TextBox",
                              "control":"TextBox"
                           },
                           "text":{
                              "value":"Id",
                              "control":"TextBox"
                           },
                           "actions":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "readOnly":{
                              "value":true,
                              "control":"CheckBox"
                           },
                           "placeholder":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "toolTip":{
                              "value":false,
                              "control":"CheckBox"
                           },
                           "toolTipText":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "maxLength":{
                              "value":200,
                              "control":"TextBox"
                           },
                           "type":{
                              "value":"String",
                              "control":"ListBox",
                              "values":[
                                 {
                                    "id":"0",
                                    "item":"String",
                                    "value":"String"
                                 },
                                 {
                                    "id":"1",
                                    "item":"Integer",
                                    "value":"Integer"
                                 },
                                 {
                                    "id":"2",
                                    "item":"Decimal",
                                    "value":"Decimal"
                                 }
                              ]
                           },
                           "masks":{
                              "value":"",
                              "control":"TextBox",
                              "maskValue":""
                           },
                           "validations":{
                              "value":"",
                              "control":"ListBoxCheckBox",
                              "selectedValues":[
                                 
                              ],
                              "values":[
                                 {
                                    "id":"1",
                                    "item":"REQUIRE",
                                    "value":{
                                       "id":"1",
                                       "type":"REQUIRE",
                                       "events":[
                                          "onBlur",
                                          "onSubmit"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"2",
                                    "item":"NUMBER",
                                    "value":{
                                       "id":"2",
                                       "type":"NUMBER",
                                       "events":[
                                          "onChange",
                                          "onkeyPress"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"3",
                                    "item":"EMAIL",
                                    "value":{
                                       "id":"3",
                                       "type":"EMAIL",
                                       "events":[
                                          "onBlur"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"4",
                                    "item":"UNIQUE",
                                    "value":{
                                       "id":"4",
                                       "type":"UNIQUE",
                                       "events":[
                                          "onBlur"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"5",
                                    "item":"NOSPACE",
                                    "value":{
                                       "id":"5",
                                       "type":"NOSPACE",
                                       "events":[
                                          "onkeyPress"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"6",
                                    "item":"NOSPECIALCHAR",
                                    "value":{
                                       "id":"6",
                                       "type":"NOSPECIALCHAR",
                                       "events":[
                                          "onkeyPress"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"7",
                                    "item":"PATTERN",
                                    "value":{
                                       "id":"7",
                                       "type":"PATTERN",
                                       "events":[
                                          "onBlur"
                                       ]
                                    }
                                 }
                              ]
                           },
                           "operators":{
                              "value":"",
                              "control":"ListBoxCheckBox",
                              "selectedValues":[
                                 
                              ],
                              "values":[
                                 {
                                    "id":"1",
                                    "item":"equal",
                                    "value":{
                                       "id":"1",
                                       "type":"equal"
                                    }
                                 },
                                 {
                                    "id":"2",
                                    "item":"not equal",
                                    "value":{
                                       "id":"2",
                                       "type":"not equal"
                                    }
                                 },
                                 {
                                    "id":"3",
                                    "item":"greater",
                                    "value":{
                                       "id":"3",
                                       "type":"greater"
                                    }
                                 },
                                 {
                                    "id":"4",
                                    "item":"greater & equal",
                                    "value":{
                                       "id":"4",
                                       "type":"greater & equal"
                                    }
                                 },
                                 {
                                    "id":"5",
                                    "item":"lower",
                                    "value":{
                                       "id":"5",
                                       "type":"lower"
                                    }
                                 },
                                 {
                                    "id":"6",
                                    "item":"lower & equal",
                                    "value":{
                                       "id":"6",
                                       "type":"lower & equal"
                                    }
                                 },
                                 {
                                    "id":"7",
                                    "item":"contains",
                                    "value":{
                                       "id":"7",
                                       "type":"contains"
                                    }
                                 },
                                 {
                                    "id":"8",
                                    "item":"starts with",
                                    "value":{
                                       "id":"8",
                                       "type":"starts with"
                                    }
                                 },
                                 {
                                    "id":"9",
                                    "item":"ends with",
                                    "value":{
                                       "id":"9",
                                       "type":"ends with"
                                    }
                                 }
                              ]
                           },
                           "prefix":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "suffix":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "wholeNumberLength":{
                              "value":10,
                              "control":"TextBox"
                           },
                           "decimalSize":{
                              "value":2,
                              "control":"TextBox"
                           },
                           "decimalSeparator":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "groupSize":{
                              "value":3,
                              "control":"TextBox"
                           },
                           "groupSeparator":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "index":{
                              "value":false,
                              "control":"CheckBox"
                           }
                        },
                        "policy":{
                           "read":true,
                           "edit":true,
                           "delete":true
                        },
                        "styles":{
                           "fontSize":{
                              "value":"14px"
                           },
                           "fontFamily":{
                              "value":"Arial"
                           },
                           "color":{
                              "value":"#212121"
                           },
                           "left":{
                              "value":10,
                              "hide":true
                           },
                           "top":{
                              "value":50,
                              "hide":true
                           },
                           "width":{
                              "value":"48px",
                              "hide":true
                           },
                           "display":{
                              "value":"flex",
                              "hide":true
                           },
                           "height":{
                              "value":"25px",
                              "hide":true
                           },
                           "visibility":{
                              "value":"visible"
                           },
                           "borderLeft":{
                              "value":"1px solid #cccccc"
                           },
                           "borderTop":{
                              "value":"1px solid #cccccc"
                           },
                           "borderTopLeftRadius":{
                              "value":"2px"
                           },
                           "borderTopRightRadius":{
                              "value":"2px"
                           },
                           "borderRight":{
                              "value":"1px solid #cccccc"
                           },
                           "borderBottom":{
                              "value":"1px solid #cccccc"
                           },
                           "borderBottomLeftRadius":{
                              "value":"2px"
                           },
                           "borderBottomRightRadius":{
                              "value":"2px"
                           },
                           "background":{
                              "value":"white"
                           },
                           "boxSizing":{
                              "value":"border-box",
                              "hide":true
                           },
                           "textAlign":{
                              "value":"left"
                           },
                           "resize":{
                              "value":"both",
                              "hide":true
                           },
                           "overflow":{
                              "value":"auto",
                              "hide":true
                           }
                        },
                        "globalId":"8008f433-664f-422c-adb2-80158683f39c",
                        "parentId":[
                           7,
                           5,
                           1
                        ],
                        "parentGlobalId":[
                           "529f784d-820a-42c3-b0aa-7920146178cc",
                           "55bcafe9-3c5d-49d8-a7a0-f6504879f17e",
                           "4b0bd589-f5a3-4360-9dba-9ecec09b8ea1"
                        ]
                     },
                     {
                        "id":15,
                        "order":2,
                        "type":"TextBox",
                        "properties":{
                           "name":{
                              "value":"TextBox15",
                              "control":"TextBox"
                           },
                           "field":{
                              "value":"TextBox",
                              "control":"TextBox"
                           },
                           "text":{
                              "value":"First Name",
                              "control":"TextBox"
                           },
                           "actions":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "readOnly":{
                              "value":true,
                              "control":"CheckBox"
                           },
                           "placeholder":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "toolTip":{
                              "value":false,
                              "control":"CheckBox"
                           },
                           "toolTipText":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "maxLength":{
                              "value":200,
                              "control":"TextBox"
                           },
                           "type":{
                              "value":"String",
                              "control":"ListBox",
                              "values":[
                                 {
                                    "id":"0",
                                    "item":"String",
                                    "value":"String"
                                 },
                                 {
                                    "id":"1",
                                    "item":"Integer",
                                    "value":"Integer"
                                 },
                                 {
                                    "id":"2",
                                    "item":"Decimal",
                                    "value":"Decimal"
                                 }
                              ]
                           },
                           "masks":{
                              "value":"",
                              "control":"TextBox",
                              "maskValue":""
                           },
                           "validations":{
                              "value":"",
                              "control":"ListBoxCheckBox",
                              "selectedValues":[
                                 
                              ],
                              "values":[
                                 {
                                    "id":"1",
                                    "item":"REQUIRE",
                                    "value":{
                                       "id":"1",
                                       "type":"REQUIRE",
                                       "events":[
                                          "onBlur",
                                          "onSubmit"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"2",
                                    "item":"NUMBER",
                                    "value":{
                                       "id":"2",
                                       "type":"NUMBER",
                                       "events":[
                                          "onChange",
                                          "onkeyPress"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"3",
                                    "item":"EMAIL",
                                    "value":{
                                       "id":"3",
                                       "type":"EMAIL",
                                       "events":[
                                          "onBlur"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"4",
                                    "item":"UNIQUE",
                                    "value":{
                                       "id":"4",
                                       "type":"UNIQUE",
                                       "events":[
                                          "onBlur"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"5",
                                    "item":"NOSPACE",
                                    "value":{
                                       "id":"5",
                                       "type":"NOSPACE",
                                       "events":[
                                          "onkeyPress"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"6",
                                    "item":"NOSPECIALCHAR",
                                    "value":{
                                       "id":"6",
                                       "type":"NOSPECIALCHAR",
                                       "events":[
                                          "onkeyPress"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"7",
                                    "item":"PATTERN",
                                    "value":{
                                       "id":"7",
                                       "type":"PATTERN",
                                       "events":[
                                          "onBlur"
                                       ]
                                    }
                                 }
                              ]
                           },
                           "operators":{
                              "value":"",
                              "control":"ListBoxCheckBox",
                              "selectedValues":[
                                 
                              ],
                              "values":[
                                 {
                                    "id":"1",
                                    "item":"equal",
                                    "value":{
                                       "id":"1",
                                       "type":"equal"
                                    }
                                 },
                                 {
                                    "id":"2",
                                    "item":"not equal",
                                    "value":{
                                       "id":"2",
                                       "type":"not equal"
                                    }
                                 },
                                 {
                                    "id":"3",
                                    "item":"greater",
                                    "value":{
                                       "id":"3",
                                       "type":"greater"
                                    }
                                 },
                                 {
                                    "id":"4",
                                    "item":"greater & equal",
                                    "value":{
                                       "id":"4",
                                       "type":"greater & equal"
                                    }
                                 },
                                 {
                                    "id":"5",
                                    "item":"lower",
                                    "value":{
                                       "id":"5",
                                       "type":"lower"
                                    }
                                 },
                                 {
                                    "id":"6",
                                    "item":"lower & equal",
                                    "value":{
                                       "id":"6",
                                       "type":"lower & equal"
                                    }
                                 },
                                 {
                                    "id":"7",
                                    "item":"contains",
                                    "value":{
                                       "id":"7",
                                       "type":"contains"
                                    }
                                 },
                                 {
                                    "id":"8",
                                    "item":"starts with",
                                    "value":{
                                       "id":"8",
                                       "type":"starts with"
                                    }
                                 },
                                 {
                                    "id":"9",
                                    "item":"ends with",
                                    "value":{
                                       "id":"9",
                                       "type":"ends with"
                                    }
                                 }
                              ]
                           },
                           "prefix":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "suffix":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "wholeNumberLength":{
                              "value":10,
                              "control":"TextBox"
                           },
                           "decimalSize":{
                              "value":2,
                              "control":"TextBox"
                           },
                           "decimalSeparator":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "groupSize":{
                              "value":3,
                              "control":"TextBox"
                           },
                           "groupSeparator":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "index":{
                              "value":false,
                              "control":"CheckBox"
                           }
                        },
                        "policy":{
                           "read":true,
                           "edit":true,
                           "delete":true
                        },
                        "styles":{
                           "fontSize":{
                              "value":"14px"
                           },
                           "fontFamily":{
                              "value":"Arial"
                           },
                           "color":{
                              "value":"#212121"
                           },
                           "left":{
                              "value":6,
                              "hide":true
                           },
                           "top":{
                              "value":50,
                              "hide":true
                           },
                           "width":{
                              "value":"235px",
                              "hide":true
                           },
                           "display":{
                              "value":"flex",
                              "hide":true
                           },
                           "height":{
                              "value":"25px",
                              "hide":true
                           },
                           "visibility":{
                              "value":"visible"
                           },
                           "borderLeft":{
                              "value":"1px solid #cccccc"
                           },
                           "borderTop":{
                              "value":"1px solid #cccccc"
                           },
                           "borderTopLeftRadius":{
                              "value":"2px"
                           },
                           "borderTopRightRadius":{
                              "value":"2px"
                           },
                           "borderRight":{
                              "value":"1px solid #cccccc"
                           },
                           "borderBottom":{
                              "value":"1px solid #cccccc"
                           },
                           "borderBottomLeftRadius":{
                              "value":"2px"
                           },
                           "borderBottomRightRadius":{
                              "value":"2px"
                           },
                           "background":{
                              "value":"white"
                           },
                           "boxSizing":{
                              "value":"border-box",
                              "hide":true
                           },
                           "textAlign":{
                              "value":"left"
                           },
                           "resize":{
                              "value":"both",
                              "hide":true
                           },
                           "overflow":{
                              "value":"auto",
                              "hide":true
                           }
                        },
                        "globalId":"3e554094-a936-4fbd-ab53-081be4b7e7ed",
                        "parentId":[
                           7,
                           5,
                           1
                        ],
                        "parentGlobalId":[
                           "529f784d-820a-42c3-b0aa-7920146178cc",
                           "55bcafe9-3c5d-49d8-a7a0-f6504879f17e",
                           "4b0bd589-f5a3-4360-9dba-9ecec09b8ea1"
                        ]
                     },
                     {
                        "id":19,
                        "order":2,
                        "type":"TextBox",
                        "properties":{
                           "name":{
                              "value":"TextBox19",
                              "control":"TextBox"
                           },
                           "field":{
                              "value":"TextBox",
                              "control":"TextBox"
                           },
                           "text":{
                              "value":"Last name",
                              "control":"TextBox"
                           },
                           "actions":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "readOnly":{
                              "value":true,
                              "control":"CheckBox"
                           },
                           "placeholder":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "toolTip":{
                              "value":false,
                              "control":"CheckBox"
                           },
                           "toolTipText":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "maxLength":{
                              "value":200,
                              "control":"TextBox"
                           },
                           "type":{
                              "value":"String",
                              "control":"ListBox",
                              "values":[
                                 {
                                    "id":"0",
                                    "item":"String",
                                    "value":"String"
                                 },
                                 {
                                    "id":"1",
                                    "item":"Integer",
                                    "value":"Integer"
                                 },
                                 {
                                    "id":"2",
                                    "item":"Decimal",
                                    "value":"Decimal"
                                 }
                              ]
                           },
                           "masks":{
                              "value":"",
                              "control":"TextBox",
                              "maskValue":""
                           },
                           "validations":{
                              "value":"",
                              "control":"ListBoxCheckBox",
                              "selectedValues":[
                                 
                              ],
                              "values":[
                                 {
                                    "id":"1",
                                    "item":"REQUIRE",
                                    "value":{
                                       "id":"1",
                                       "type":"REQUIRE",
                                       "events":[
                                          "onBlur",
                                          "onSubmit"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"2",
                                    "item":"NUMBER",
                                    "value":{
                                       "id":"2",
                                       "type":"NUMBER",
                                       "events":[
                                          "onChange",
                                          "onkeyPress"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"3",
                                    "item":"EMAIL",
                                    "value":{
                                       "id":"3",
                                       "type":"EMAIL",
                                       "events":[
                                          "onBlur"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"4",
                                    "item":"UNIQUE",
                                    "value":{
                                       "id":"4",
                                       "type":"UNIQUE",
                                       "events":[
                                          "onBlur"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"5",
                                    "item":"NOSPACE",
                                    "value":{
                                       "id":"5",
                                       "type":"NOSPACE",
                                       "events":[
                                          "onkeyPress"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"6",
                                    "item":"NOSPECIALCHAR",
                                    "value":{
                                       "id":"6",
                                       "type":"NOSPECIALCHAR",
                                       "events":[
                                          "onkeyPress"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"7",
                                    "item":"PATTERN",
                                    "value":{
                                       "id":"7",
                                       "type":"PATTERN",
                                       "events":[
                                          "onBlur"
                                       ]
                                    }
                                 }
                              ]
                           },
                           "operators":{
                              "value":"",
                              "control":"ListBoxCheckBox",
                              "selectedValues":[
                                 
                              ],
                              "values":[
                                 {
                                    "id":"1",
                                    "item":"equal",
                                    "value":{
                                       "id":"1",
                                       "type":"equal"
                                    }
                                 },
                                 {
                                    "id":"2",
                                    "item":"not equal",
                                    "value":{
                                       "id":"2",
                                       "type":"not equal"
                                    }
                                 },
                                 {
                                    "id":"3",
                                    "item":"greater",
                                    "value":{
                                       "id":"3",
                                       "type":"greater"
                                    }
                                 },
                                 {
                                    "id":"4",
                                    "item":"greater & equal",
                                    "value":{
                                       "id":"4",
                                       "type":"greater & equal"
                                    }
                                 },
                                 {
                                    "id":"5",
                                    "item":"lower",
                                    "value":{
                                       "id":"5",
                                       "type":"lower"
                                    }
                                 },
                                 {
                                    "id":"6",
                                    "item":"lower & equal",
                                    "value":{
                                       "id":"6",
                                       "type":"lower & equal"
                                    }
                                 },
                                 {
                                    "id":"7",
                                    "item":"contains",
                                    "value":{
                                       "id":"7",
                                       "type":"contains"
                                    }
                                 },
                                 {
                                    "id":"8",
                                    "item":"starts with",
                                    "value":{
                                       "id":"8",
                                       "type":"starts with"
                                    }
                                 },
                                 {
                                    "id":"9",
                                    "item":"ends with",
                                    "value":{
                                       "id":"9",
                                       "type":"ends with"
                                    }
                                 }
                              ]
                           },
                           "prefix":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "suffix":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "wholeNumberLength":{
                              "value":10,
                              "control":"TextBox"
                           },
                           "decimalSize":{
                              "value":2,
                              "control":"TextBox"
                           },
                           "decimalSeparator":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "groupSize":{
                              "value":3,
                              "control":"TextBox"
                           },
                           "groupSeparator":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "index":{
                              "value":false,
                              "control":"CheckBox"
                           }
                        },
                        "policy":{
                           "read":true,
                           "edit":true,
                           "delete":true
                        },
                        "styles":{
                           "fontSize":{
                              "value":"14px"
                           },
                           "fontFamily":{
                              "value":"Arial"
                           },
                           "color":{
                              "value":"#212121"
                           },
                           "left":{
                              "value":10,
                              "hide":true
                           },
                           "top":{
                              "value":50,
                              "hide":true
                           },
                           "width":{
                              "value":"258px",
                              "hide":true
                           },
                           "display":{
                              "value":"flex",
                              "hide":true
                           },
                           "height":{
                              "value":"25px",
                              "hide":true
                           },
                           "visibility":{
                              "value":"visible"
                           },
                           "borderLeft":{
                              "value":"1px solid #cccccc"
                           },
                           "borderTop":{
                              "value":"1px solid #cccccc"
                           },
                           "borderTopLeftRadius":{
                              "value":"2px"
                           },
                           "borderTopRightRadius":{
                              "value":"2px"
                           },
                           "borderRight":{
                              "value":"1px solid #cccccc"
                           },
                           "borderBottom":{
                              "value":"1px solid #cccccc"
                           },
                           "borderBottomLeftRadius":{
                              "value":"2px"
                           },
                           "borderBottomRightRadius":{
                              "value":"2px"
                           },
                           "background":{
                              "value":"white"
                           },
                           "boxSizing":{
                              "value":"border-box",
                              "hide":true
                           },
                           "textAlign":{
                              "value":"left"
                           },
                           "resize":{
                              "value":"both",
                              "hide":true
                           },
                           "overflow":{
                              "value":"auto",
                              "hide":true
                           }
                        },
                        "globalId":"35d54d93-d7b6-4682-905b-5e36ab3b8737",
                        "parentId":[
                           7,
                           5,
                           1
                        ],
                        "parentGlobalId":[
                           "529f784d-820a-42c3-b0aa-7920146178cc",
                           "55bcafe9-3c5d-49d8-a7a0-f6504879f17e",
                           "4b0bd589-f5a3-4360-9dba-9ecec09b8ea1"
                        ]
                     },
                     {
                        "id":27,
                        "order":2,
                        "type":"TextBox",
                        "properties":{
                           "name":{
                              "value":"TextBox27",
                              "control":"TextBox"
                           },
                           "field":{
                              "value":"TextBox",
                              "control":"TextBox"
                           },
                           "text":{
                              "value":"Email",
                              "control":"TextBox"
                           },
                           "actions":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "readOnly":{
                              "value":true,
                              "control":"CheckBox"
                           },
                           "placeholder":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "toolTip":{
                              "value":false,
                              "control":"CheckBox"
                           },
                           "toolTipText":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "maxLength":{
                              "value":200,
                              "control":"TextBox"
                           },
                           "type":{
                              "value":"String",
                              "control":"ListBox",
                              "values":[
                                 {
                                    "id":"0",
                                    "item":"String",
                                    "value":"String"
                                 },
                                 {
                                    "id":"1",
                                    "item":"Integer",
                                    "value":"Integer"
                                 },
                                 {
                                    "id":"2",
                                    "item":"Decimal",
                                    "value":"Decimal"
                                 }
                              ]
                           },
                           "masks":{
                              "value":"",
                              "control":"TextBox",
                              "maskValue":""
                           },
                           "validations":{
                              "value":"",
                              "control":"ListBoxCheckBox",
                              "selectedValues":[
                                 
                              ],
                              "values":[
                                 {
                                    "id":"1",
                                    "item":"REQUIRE",
                                    "value":{
                                       "id":"1",
                                       "type":"REQUIRE",
                                       "events":[
                                          "onBlur",
                                          "onSubmit"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"2",
                                    "item":"NUMBER",
                                    "value":{
                                       "id":"2",
                                       "type":"NUMBER",
                                       "events":[
                                          "onChange",
                                          "onkeyPress"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"3",
                                    "item":"EMAIL",
                                    "value":{
                                       "id":"3",
                                       "type":"EMAIL",
                                       "events":[
                                          "onBlur"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"4",
                                    "item":"UNIQUE",
                                    "value":{
                                       "id":"4",
                                       "type":"UNIQUE",
                                       "events":[
                                          "onBlur"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"5",
                                    "item":"NOSPACE",
                                    "value":{
                                       "id":"5",
                                       "type":"NOSPACE",
                                       "events":[
                                          "onkeyPress"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"6",
                                    "item":"NOSPECIALCHAR",
                                    "value":{
                                       "id":"6",
                                       "type":"NOSPECIALCHAR",
                                       "events":[
                                          "onkeyPress"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"7",
                                    "item":"PATTERN",
                                    "value":{
                                       "id":"7",
                                       "type":"PATTERN",
                                       "events":[
                                          "onBlur"
                                       ]
                                    }
                                 }
                              ]
                           },
                           "operators":{
                              "value":"",
                              "control":"ListBoxCheckBox",
                              "selectedValues":[
                                 
                              ],
                              "values":[
                                 {
                                    "id":"1",
                                    "item":"equal",
                                    "value":{
                                       "id":"1",
                                       "type":"equal"
                                    }
                                 },
                                 {
                                    "id":"2",
                                    "item":"not equal",
                                    "value":{
                                       "id":"2",
                                       "type":"not equal"
                                    }
                                 },
                                 {
                                    "id":"3",
                                    "item":"greater",
                                    "value":{
                                       "id":"3",
                                       "type":"greater"
                                    }
                                 },
                                 {
                                    "id":"4",
                                    "item":"greater & equal",
                                    "value":{
                                       "id":"4",
                                       "type":"greater & equal"
                                    }
                                 },
                                 {
                                    "id":"5",
                                    "item":"lower",
                                    "value":{
                                       "id":"5",
                                       "type":"lower"
                                    }
                                 },
                                 {
                                    "id":"6",
                                    "item":"lower & equal",
                                    "value":{
                                       "id":"6",
                                       "type":"lower & equal"
                                    }
                                 },
                                 {
                                    "id":"7",
                                    "item":"contains",
                                    "value":{
                                       "id":"7",
                                       "type":"contains"
                                    }
                                 },
                                 {
                                    "id":"8",
                                    "item":"starts with",
                                    "value":{
                                       "id":"8",
                                       "type":"starts with"
                                    }
                                 },
                                 {
                                    "id":"9",
                                    "item":"ends with",
                                    "value":{
                                       "id":"9",
                                       "type":"ends with"
                                    }
                                 }
                              ]
                           },
                           "prefix":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "suffix":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "wholeNumberLength":{
                              "value":10,
                              "control":"TextBox"
                           },
                           "decimalSize":{
                              "value":2,
                              "control":"TextBox"
                           },
                           "decimalSeparator":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "groupSize":{
                              "value":3,
                              "control":"TextBox"
                           },
                           "groupSeparator":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "index":{
                              "value":false,
                              "control":"CheckBox"
                           }
                        },
                        "policy":{
                           "read":true,
                           "edit":true,
                           "delete":true
                        },
                        "styles":{
                           "fontSize":{
                              "value":"14px"
                           },
                           "fontFamily":{
                              "value":"Arial"
                           },
                           "color":{
                              "value":"#212121"
                           },
                           "left":{
                              "value":10,
                              "hide":true
                           },
                           "top":{
                              "value":50,
                              "hide":true
                           },
                           "width":{
                              "value":"224px",
                              "hide":true
                           },
                           "display":{
                              "value":"flex",
                              "hide":true
                           },
                           "height":{
                              "value":"25px",
                              "hide":true
                           },
                           "visibility":{
                              "value":"visible"
                           },
                           "borderLeft":{
                              "value":"1px solid #cccccc"
                           },
                           "borderTop":{
                              "value":"1px solid #cccccc"
                           },
                           "borderTopLeftRadius":{
                              "value":"2px"
                           },
                           "borderTopRightRadius":{
                              "value":"2px"
                           },
                           "borderRight":{
                              "value":"1px solid #cccccc"
                           },
                           "borderBottom":{
                              "value":"1px solid #cccccc"
                           },
                           "borderBottomLeftRadius":{
                              "value":"2px"
                           },
                           "borderBottomRightRadius":{
                              "value":"2px"
                           },
                           "background":{
                              "value":"white"
                           },
                           "boxSizing":{
                              "value":"border-box",
                              "hide":true
                           },
                           "textAlign":{
                              "value":"left"
                           },
                           "resize":{
                              "value":"both",
                              "hide":true
                           },
                           "overflow":{
                              "value":"auto",
                              "hide":true
                           }
                        },
                        "globalId":"1031f425-bf9b-4457-9907-0ec920ab5bd6",
                        "parentId":[
                           7,
                           5,
                           1
                        ],
                        "parentGlobalId":[
                           "529f784d-820a-42c3-b0aa-7920146178cc",
                           "55bcafe9-3c5d-49d8-a7a0-f6504879f17e",
                           "4b0bd589-f5a3-4360-9dba-9ecec09b8ea1"
                        ]
                     }
                  ],
                  "policy":{
                     "read":true,
                     "edit":true,
                     "delete":true
                  },
                  "styles":{
                     "fontSize":{
                        "value":"14px"
                     },
                     "fontFamily":{
                        "value":"Arial"
                     },
                     "color":{
                        "value":"#cccccc"
                     },
                     "backgroundColor":{
                        "value":"#e7e7e7"
                     },
                     "height":{
                        "value":"30px",
                        "hide":true
                     },
                     "width":{
                        "value":"100%",
                        "hide":true
                     },
                     "display":{
                        "value":"flex",
                        "hide":true
                     },
                     "position":{
                        "value":"relative",
                        "hide":true
                     },
                     "boxSizing":{
                        "value":"border-box",
                        "hide":true
                     },
                     "overflow":{
                        "value":"hidden",
                        "hide":true
                     },
                     "border":{
                        "value":"1px solid #cccccc"
                     }
                  },
                  "left":{
                     "value":5
                  },
                  "top":{
                     "value":59
                  },
                  "globalId":"529f784d-820a-42c3-b0aa-7920146178cc",
                  "parentId":[
                     5,
                     1
                  ],
                  "parentGlobalId":[
                     "55bcafe9-3c5d-49d8-a7a0-f6504879f17e",
                     "4b0bd589-f5a3-4360-9dba-9ecec09b8ea1"
                  ]
               },
               {
                  "id":8,
                  "order":5,
                  "currentMaxId":0,
                  "type":"Filter",
                  "properties":{
                     "name":{
                        "value":"Filter8",
                        "control":"TextBox"
                     },
                     "text":{
                        "value":"Filter",
                        "control":"TextBox"
                     }
                  },
                  "metaData":[
                     {
                        "id":13,
                        "order":2,
                        "type":"TextBox",
                        "properties":{
                           "name":{
                              "value":"TextBox13",
                              "control":"TextBox"
                           },
                           "field":{
                              "value":"TextBox",
                              "control":"TextBox"
                           },
                           "text":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "actions":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "readOnly":{
                              "value":false,
                              "control":"CheckBox"
                           },
                           "placeholder":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "toolTip":{
                              "value":false,
                              "control":"CheckBox"
                           },
                           "toolTipText":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "maxLength":{
                              "value":200,
                              "control":"TextBox"
                           },
                           "type":{
                              "value":"String",
                              "control":"ListBox",
                              "values":[
                                 {
                                    "id":"0",
                                    "item":"String",
                                    "value":"String"
                                 },
                                 {
                                    "id":"1",
                                    "item":"Integer",
                                    "value":"Integer"
                                 },
                                 {
                                    "id":"2",
                                    "item":"Decimal",
                                    "value":"Decimal"
                                 }
                              ]
                           },
                           "masks":{
                              "value":"",
                              "control":"TextBox",
                              "maskValue":""
                           },
                           "validations":{
                              "value":"",
                              "control":"ListBoxCheckBox",
                              "selectedValues":[
                                 
                              ],
                              "values":[
                                 {
                                    "id":"1",
                                    "item":"REQUIRE",
                                    "value":{
                                       "id":"1",
                                       "type":"REQUIRE",
                                       "events":[
                                          "onBlur",
                                          "onSubmit"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"2",
                                    "item":"NUMBER",
                                    "value":{
                                       "id":"2",
                                       "type":"NUMBER",
                                       "events":[
                                          "onChange",
                                          "onkeyPress"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"3",
                                    "item":"EMAIL",
                                    "value":{
                                       "id":"3",
                                       "type":"EMAIL",
                                       "events":[
                                          "onBlur"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"4",
                                    "item":"UNIQUE",
                                    "value":{
                                       "id":"4",
                                       "type":"UNIQUE",
                                       "events":[
                                          "onBlur"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"5",
                                    "item":"NOSPACE",
                                    "value":{
                                       "id":"5",
                                       "type":"NOSPACE",
                                       "events":[
                                          "onkeyPress"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"6",
                                    "item":"NOSPECIALCHAR",
                                    "value":{
                                       "id":"6",
                                       "type":"NOSPECIALCHAR",
                                       "events":[
                                          "onkeyPress"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"7",
                                    "item":"PATTERN",
                                    "value":{
                                       "id":"7",
                                       "type":"PATTERN",
                                       "events":[
                                          "onBlur"
                                       ]
                                    }
                                 }
                              ]
                           },
                           "operators":{
                              "value":"",
                              "control":"ListBoxCheckBox",
                              "selectedValues":[
                                 
                              ],
                              "values":[
                                 {
                                    "id":"1",
                                    "item":"equal",
                                    "value":{
                                       "id":"1",
                                       "type":"equal"
                                    }
                                 },
                                 {
                                    "id":"2",
                                    "item":"not equal",
                                    "value":{
                                       "id":"2",
                                       "type":"not equal"
                                    }
                                 },
                                 {
                                    "id":"3",
                                    "item":"greater",
                                    "value":{
                                       "id":"3",
                                       "type":"greater"
                                    }
                                 },
                                 {
                                    "id":"4",
                                    "item":"greater & equal",
                                    "value":{
                                       "id":"4",
                                       "type":"greater & equal"
                                    }
                                 },
                                 {
                                    "id":"5",
                                    "item":"lower",
                                    "value":{
                                       "id":"5",
                                       "type":"lower"
                                    }
                                 },
                                 {
                                    "id":"6",
                                    "item":"lower & equal",
                                    "value":{
                                       "id":"6",
                                       "type":"lower & equal"
                                    }
                                 },
                                 {
                                    "id":"7",
                                    "item":"contains",
                                    "value":{
                                       "id":"7",
                                       "type":"contains"
                                    }
                                 },
                                 {
                                    "id":"8",
                                    "item":"starts with",
                                    "value":{
                                       "id":"8",
                                       "type":"starts with"
                                    }
                                 },
                                 {
                                    "id":"9",
                                    "item":"ends with",
                                    "value":{
                                       "id":"9",
                                       "type":"ends with"
                                    }
                                 }
                              ]
                           },
                           "prefix":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "suffix":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "wholeNumberLength":{
                              "value":10,
                              "control":"TextBox"
                           },
                           "decimalSize":{
                              "value":2,
                              "control":"TextBox"
                           },
                           "decimalSeparator":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "groupSize":{
                              "value":3,
                              "control":"TextBox"
                           },
                           "groupSeparator":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "index":{
                              "value":false,
                              "control":"CheckBox"
                           }
                        },
                        "policy":{
                           "read":true,
                           "edit":true,
                           "delete":true
                        },
                        "styles":{
                           "fontSize":{
                              "value":"14px"
                           },
                           "fontFamily":{
                              "value":"Arial"
                           },
                           "color":{
                              "value":"#212121"
                           },
                           "left":{
                              "value":10,
                              "hide":true
                           },
                           "top":{
                              "value":50,
                              "hide":true
                           },
                           "width":{
                              "value":"48px",
                              "hide":true
                           },
                           "display":{
                              "value":"flex",
                              "hide":true
                           },
                           "height":{
                              "value":"25px",
                              "hide":true
                           },
                           "visibility":{
                              "value":"visible"
                           },
                           "borderLeft":{
                              "value":"1px solid #cccccc"
                           },
                           "borderTop":{
                              "value":"1px solid #cccccc"
                           },
                           "borderTopLeftRadius":{
                              "value":"2px"
                           },
                           "borderTopRightRadius":{
                              "value":"2px"
                           },
                           "borderRight":{
                              "value":"1px solid #cccccc"
                           },
                           "borderBottom":{
                              "value":"1px solid #cccccc"
                           },
                           "borderBottomLeftRadius":{
                              "value":"2px"
                           },
                           "borderBottomRightRadius":{
                              "value":"2px"
                           },
                           "background":{
                              "value":"white"
                           },
                           "boxSizing":{
                              "value":"border-box",
                              "hide":true
                           },
                           "textAlign":{
                              "value":"left"
                           },
                           "resize":{
                              "value":"both",
                              "hide":true
                           },
                           "overflow":{
                              "value":"auto",
                              "hide":true
                           }
                        },
                        "globalId":"b9d2c854-481c-48e9-b143-1fef628c441e",
                        "parentId":[
                           8,
                           5,
                           1
                        ],
                        "parentGlobalId":[
                           "8af4353a-b9c3-41c9-a7e3-ef91e8112d40",
                           "55bcafe9-3c5d-49d8-a7a0-f6504879f17e",
                           "4b0bd589-f5a3-4360-9dba-9ecec09b8ea1"
                        ],
                        "headerId":11
                     },
                     {
                        "id":17,
                        "order":2,
                        "type":"TextBox",
                        "properties":{
                           "name":{
                              "value":"TextBox17",
                              "control":"TextBox"
                           },
                           "field":{
                              "value":"TextBox",
                              "control":"TextBox"
                           },
                           "text":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "actions":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "readOnly":{
                              "value":false,
                              "control":"CheckBox"
                           },
                           "placeholder":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "toolTip":{
                              "value":false,
                              "control":"CheckBox"
                           },
                           "toolTipText":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "maxLength":{
                              "value":200,
                              "control":"TextBox"
                           },
                           "type":{
                              "value":"String",
                              "control":"ListBox",
                              "values":[
                                 {
                                    "id":"0",
                                    "item":"String",
                                    "value":"String"
                                 },
                                 {
                                    "id":"1",
                                    "item":"Integer",
                                    "value":"Integer"
                                 },
                                 {
                                    "id":"2",
                                    "item":"Decimal",
                                    "value":"Decimal"
                                 }
                              ]
                           },
                           "masks":{
                              "value":"",
                              "control":"TextBox",
                              "maskValue":""
                           },
                           "validations":{
                              "value":"",
                              "control":"ListBoxCheckBox",
                              "selectedValues":[
                                 
                              ],
                              "values":[
                                 {
                                    "id":"1",
                                    "item":"REQUIRE",
                                    "value":{
                                       "id":"1",
                                       "type":"REQUIRE",
                                       "events":[
                                          "onBlur",
                                          "onSubmit"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"2",
                                    "item":"NUMBER",
                                    "value":{
                                       "id":"2",
                                       "type":"NUMBER",
                                       "events":[
                                          "onChange",
                                          "onkeyPress"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"3",
                                    "item":"EMAIL",
                                    "value":{
                                       "id":"3",
                                       "type":"EMAIL",
                                       "events":[
                                          "onBlur"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"4",
                                    "item":"UNIQUE",
                                    "value":{
                                       "id":"4",
                                       "type":"UNIQUE",
                                       "events":[
                                          "onBlur"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"5",
                                    "item":"NOSPACE",
                                    "value":{
                                       "id":"5",
                                       "type":"NOSPACE",
                                       "events":[
                                          "onkeyPress"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"6",
                                    "item":"NOSPECIALCHAR",
                                    "value":{
                                       "id":"6",
                                       "type":"NOSPECIALCHAR",
                                       "events":[
                                          "onkeyPress"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"7",
                                    "item":"PATTERN",
                                    "value":{
                                       "id":"7",
                                       "type":"PATTERN",
                                       "events":[
                                          "onBlur"
                                       ]
                                    }
                                 }
                              ]
                           },
                           "operators":{
                              "value":"",
                              "control":"ListBoxCheckBox",
                              "selectedValues":[
                                 
                              ],
                              "values":[
                                 {
                                    "id":"1",
                                    "item":"equal",
                                    "value":{
                                       "id":"1",
                                       "type":"equal"
                                    }
                                 },
                                 {
                                    "id":"2",
                                    "item":"not equal",
                                    "value":{
                                       "id":"2",
                                       "type":"not equal"
                                    }
                                 },
                                 {
                                    "id":"3",
                                    "item":"greater",
                                    "value":{
                                       "id":"3",
                                       "type":"greater"
                                    }
                                 },
                                 {
                                    "id":"4",
                                    "item":"greater & equal",
                                    "value":{
                                       "id":"4",
                                       "type":"greater & equal"
                                    }
                                 },
                                 {
                                    "id":"5",
                                    "item":"lower",
                                    "value":{
                                       "id":"5",
                                       "type":"lower"
                                    }
                                 },
                                 {
                                    "id":"6",
                                    "item":"lower & equal",
                                    "value":{
                                       "id":"6",
                                       "type":"lower & equal"
                                    }
                                 },
                                 {
                                    "id":"7",
                                    "item":"contains",
                                    "value":{
                                       "id":"7",
                                       "type":"contains"
                                    }
                                 },
                                 {
                                    "id":"8",
                                    "item":"starts with",
                                    "value":{
                                       "id":"8",
                                       "type":"starts with"
                                    }
                                 },
                                 {
                                    "id":"9",
                                    "item":"ends with",
                                    "value":{
                                       "id":"9",
                                       "type":"ends with"
                                    }
                                 }
                              ]
                           },
                           "prefix":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "suffix":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "wholeNumberLength":{
                              "value":10,
                              "control":"TextBox"
                           },
                           "decimalSize":{
                              "value":2,
                              "control":"TextBox"
                           },
                           "decimalSeparator":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "groupSize":{
                              "value":3,
                              "control":"TextBox"
                           },
                           "groupSeparator":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "index":{
                              "value":false,
                              "control":"CheckBox"
                           }
                        },
                        "policy":{
                           "read":true,
                           "edit":true,
                           "delete":true
                        },
                        "styles":{
                           "fontSize":{
                              "value":"14px"
                           },
                           "fontFamily":{
                              "value":"Arial"
                           },
                           "color":{
                              "value":"#212121"
                           },
                           "left":{
                              "value":10,
                              "hide":true
                           },
                           "top":{
                              "value":50,
                              "hide":true
                           },
                           "width":{
                              "value":"235px",
                              "hide":true
                           },
                           "display":{
                              "value":"flex",
                              "hide":true
                           },
                           "height":{
                              "value":"25px",
                              "hide":true
                           },
                           "visibility":{
                              "value":"visible"
                           },
                           "borderLeft":{
                              "value":"1px solid #cccccc"
                           },
                           "borderTop":{
                              "value":"1px solid #cccccc"
                           },
                           "borderTopLeftRadius":{
                              "value":"2px"
                           },
                           "borderTopRightRadius":{
                              "value":"2px"
                           },
                           "borderRight":{
                              "value":"1px solid #cccccc"
                           },
                           "borderBottom":{
                              "value":"1px solid #cccccc"
                           },
                           "borderBottomLeftRadius":{
                              "value":"2px"
                           },
                           "borderBottomRightRadius":{
                              "value":"2px"
                           },
                           "background":{
                              "value":"white"
                           },
                           "boxSizing":{
                              "value":"border-box",
                              "hide":true
                           },
                           "textAlign":{
                              "value":"left"
                           },
                           "resize":{
                              "value":"both",
                              "hide":true
                           },
                           "overflow":{
                              "value":"auto",
                              "hide":true
                           }
                        },
                        "globalId":"9fe160f1-1c20-4ca7-af9a-4a6b25db3604",
                        "parentId":[
                           8,
                           5,
                           1
                        ],
                        "parentGlobalId":[
                           "8af4353a-b9c3-41c9-a7e3-ef91e8112d40",
                           "55bcafe9-3c5d-49d8-a7a0-f6504879f17e",
                           "4b0bd589-f5a3-4360-9dba-9ecec09b8ea1"
                        ],
                        "headerId":15
                     },
                     {
                        "id":21,
                        "order":2,
                        "type":"TextBox",
                        "properties":{
                           "name":{
                              "value":"TextBox21",
                              "control":"TextBox"
                           },
                           "field":{
                              "value":"TextBox",
                              "control":"TextBox"
                           },
                           "text":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "actions":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "readOnly":{
                              "value":false,
                              "control":"CheckBox"
                           },
                           "placeholder":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "toolTip":{
                              "value":false,
                              "control":"CheckBox"
                           },
                           "toolTipText":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "maxLength":{
                              "value":200,
                              "control":"TextBox"
                           },
                           "type":{
                              "value":"String",
                              "control":"ListBox",
                              "values":[
                                 {
                                    "id":"0",
                                    "item":"String",
                                    "value":"String"
                                 },
                                 {
                                    "id":"1",
                                    "item":"Integer",
                                    "value":"Integer"
                                 },
                                 {
                                    "id":"2",
                                    "item":"Decimal",
                                    "value":"Decimal"
                                 }
                              ]
                           },
                           "masks":{
                              "value":"",
                              "control":"TextBox",
                              "maskValue":""
                           },
                           "validations":{
                              "value":"",
                              "control":"ListBoxCheckBox",
                              "selectedValues":[
                                 
                              ],
                              "values":[
                                 {
                                    "id":"1",
                                    "item":"REQUIRE",
                                    "value":{
                                       "id":"1",
                                       "type":"REQUIRE",
                                       "events":[
                                          "onBlur",
                                          "onSubmit"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"2",
                                    "item":"NUMBER",
                                    "value":{
                                       "id":"2",
                                       "type":"NUMBER",
                                       "events":[
                                          "onChange",
                                          "onkeyPress"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"3",
                                    "item":"EMAIL",
                                    "value":{
                                       "id":"3",
                                       "type":"EMAIL",
                                       "events":[
                                          "onBlur"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"4",
                                    "item":"UNIQUE",
                                    "value":{
                                       "id":"4",
                                       "type":"UNIQUE",
                                       "events":[
                                          "onBlur"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"5",
                                    "item":"NOSPACE",
                                    "value":{
                                       "id":"5",
                                       "type":"NOSPACE",
                                       "events":[
                                          "onkeyPress"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"6",
                                    "item":"NOSPECIALCHAR",
                                    "value":{
                                       "id":"6",
                                       "type":"NOSPECIALCHAR",
                                       "events":[
                                          "onkeyPress"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"7",
                                    "item":"PATTERN",
                                    "value":{
                                       "id":"7",
                                       "type":"PATTERN",
                                       "events":[
                                          "onBlur"
                                       ]
                                    }
                                 }
                              ]
                           },
                           "operators":{
                              "value":"",
                              "control":"ListBoxCheckBox",
                              "selectedValues":[
                                 
                              ],
                              "values":[
                                 {
                                    "id":"1",
                                    "item":"equal",
                                    "value":{
                                       "id":"1",
                                       "type":"equal"
                                    }
                                 },
                                 {
                                    "id":"2",
                                    "item":"not equal",
                                    "value":{
                                       "id":"2",
                                       "type":"not equal"
                                    }
                                 },
                                 {
                                    "id":"3",
                                    "item":"greater",
                                    "value":{
                                       "id":"3",
                                       "type":"greater"
                                    }
                                 },
                                 {
                                    "id":"4",
                                    "item":"greater & equal",
                                    "value":{
                                       "id":"4",
                                       "type":"greater & equal"
                                    }
                                 },
                                 {
                                    "id":"5",
                                    "item":"lower",
                                    "value":{
                                       "id":"5",
                                       "type":"lower"
                                    }
                                 },
                                 {
                                    "id":"6",
                                    "item":"lower & equal",
                                    "value":{
                                       "id":"6",
                                       "type":"lower & equal"
                                    }
                                 },
                                 {
                                    "id":"7",
                                    "item":"contains",
                                    "value":{
                                       "id":"7",
                                       "type":"contains"
                                    }
                                 },
                                 {
                                    "id":"8",
                                    "item":"starts with",
                                    "value":{
                                       "id":"8",
                                       "type":"starts with"
                                    }
                                 },
                                 {
                                    "id":"9",
                                    "item":"ends with",
                                    "value":{
                                       "id":"9",
                                       "type":"ends with"
                                    }
                                 }
                              ]
                           },
                           "prefix":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "suffix":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "wholeNumberLength":{
                              "value":10,
                              "control":"TextBox"
                           },
                           "decimalSize":{
                              "value":2,
                              "control":"TextBox"
                           },
                           "decimalSeparator":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "groupSize":{
                              "value":3,
                              "control":"TextBox"
                           },
                           "groupSeparator":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "index":{
                              "value":false,
                              "control":"CheckBox"
                           }
                        },
                        "policy":{
                           "read":true,
                           "edit":true,
                           "delete":true
                        },
                        "styles":{
                           "fontSize":{
                              "value":"14px"
                           },
                           "fontFamily":{
                              "value":"Arial"
                           },
                           "color":{
                              "value":"#212121"
                           },
                           "left":{
                              "value":10,
                              "hide":true
                           },
                           "top":{
                              "value":50,
                              "hide":true
                           },
                           "width":{
                              "value":"258px",
                              "hide":true
                           },
                           "display":{
                              "value":"flex",
                              "hide":true
                           },
                           "height":{
                              "value":"25px",
                              "hide":true
                           },
                           "visibility":{
                              "value":"visible"
                           },
                           "borderLeft":{
                              "value":"1px solid #cccccc"
                           },
                           "borderTop":{
                              "value":"1px solid #cccccc"
                           },
                           "borderTopLeftRadius":{
                              "value":"2px"
                           },
                           "borderTopRightRadius":{
                              "value":"2px"
                           },
                           "borderRight":{
                              "value":"1px solid #cccccc"
                           },
                           "borderBottom":{
                              "value":"1px solid #cccccc"
                           },
                           "borderBottomLeftRadius":{
                              "value":"2px"
                           },
                           "borderBottomRightRadius":{
                              "value":"2px"
                           },
                           "background":{
                              "value":"white"
                           },
                           "boxSizing":{
                              "value":"border-box",
                              "hide":true
                           },
                           "textAlign":{
                              "value":"left"
                           },
                           "resize":{
                              "value":"both",
                              "hide":true
                           },
                           "overflow":{
                              "value":"auto",
                              "hide":true
                           }
                        },
                        "globalId":"1625e8df-9474-4be4-92cb-9030d95e702e",
                        "parentId":[
                           8,
                           5,
                           1
                        ],
                        "parentGlobalId":[
                           "8af4353a-b9c3-41c9-a7e3-ef91e8112d40",
                           "55bcafe9-3c5d-49d8-a7a0-f6504879f17e",
                           "4b0bd589-f5a3-4360-9dba-9ecec09b8ea1"
                        ],
                        "headerId":19
                     },
                     {
                        "id":29,
                        "order":2,
                        "type":"TextBox",
                        "properties":{
                           "name":{
                              "value":"TextBox29",
                              "control":"TextBox"
                           },
                           "field":{
                              "value":"TextBox",
                              "control":"TextBox"
                           },
                           "text":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "actions":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "readOnly":{
                              "value":false,
                              "control":"CheckBox"
                           },
                           "placeholder":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "toolTip":{
                              "value":false,
                              "control":"CheckBox"
                           },
                           "toolTipText":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "maxLength":{
                              "value":200,
                              "control":"TextBox"
                           },
                           "type":{
                              "value":"String",
                              "control":"ListBox",
                              "values":[
                                 {
                                    "id":"0",
                                    "item":"String",
                                    "value":"String"
                                 },
                                 {
                                    "id":"1",
                                    "item":"Integer",
                                    "value":"Integer"
                                 },
                                 {
                                    "id":"2",
                                    "item":"Decimal",
                                    "value":"Decimal"
                                 }
                              ]
                           },
                           "masks":{
                              "value":"",
                              "control":"TextBox",
                              "maskValue":""
                           },
                           "validations":{
                              "value":"",
                              "control":"ListBoxCheckBox",
                              "selectedValues":[
                                 
                              ],
                              "values":[
                                 {
                                    "id":"1",
                                    "item":"REQUIRE",
                                    "value":{
                                       "id":"1",
                                       "type":"REQUIRE",
                                       "events":[
                                          "onBlur",
                                          "onSubmit"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"2",
                                    "item":"NUMBER",
                                    "value":{
                                       "id":"2",
                                       "type":"NUMBER",
                                       "events":[
                                          "onChange",
                                          "onkeyPress"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"3",
                                    "item":"EMAIL",
                                    "value":{
                                       "id":"3",
                                       "type":"EMAIL",
                                       "events":[
                                          "onBlur"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"4",
                                    "item":"UNIQUE",
                                    "value":{
                                       "id":"4",
                                       "type":"UNIQUE",
                                       "events":[
                                          "onBlur"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"5",
                                    "item":"NOSPACE",
                                    "value":{
                                       "id":"5",
                                       "type":"NOSPACE",
                                       "events":[
                                          "onkeyPress"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"6",
                                    "item":"NOSPECIALCHAR",
                                    "value":{
                                       "id":"6",
                                       "type":"NOSPECIALCHAR",
                                       "events":[
                                          "onkeyPress"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"7",
                                    "item":"PATTERN",
                                    "value":{
                                       "id":"7",
                                       "type":"PATTERN",
                                       "events":[
                                          "onBlur"
                                       ]
                                    }
                                 }
                              ]
                           },
                           "operators":{
                              "value":"",
                              "control":"ListBoxCheckBox",
                              "selectedValues":[
                                 
                              ],
                              "values":[
                                 {
                                    "id":"1",
                                    "item":"equal",
                                    "value":{
                                       "id":"1",
                                       "type":"equal"
                                    }
                                 },
                                 {
                                    "id":"2",
                                    "item":"not equal",
                                    "value":{
                                       "id":"2",
                                       "type":"not equal"
                                    }
                                 },
                                 {
                                    "id":"3",
                                    "item":"greater",
                                    "value":{
                                       "id":"3",
                                       "type":"greater"
                                    }
                                 },
                                 {
                                    "id":"4",
                                    "item":"greater & equal",
                                    "value":{
                                       "id":"4",
                                       "type":"greater & equal"
                                    }
                                 },
                                 {
                                    "id":"5",
                                    "item":"lower",
                                    "value":{
                                       "id":"5",
                                       "type":"lower"
                                    }
                                 },
                                 {
                                    "id":"6",
                                    "item":"lower & equal",
                                    "value":{
                                       "id":"6",
                                       "type":"lower & equal"
                                    }
                                 },
                                 {
                                    "id":"7",
                                    "item":"contains",
                                    "value":{
                                       "id":"7",
                                       "type":"contains"
                                    }
                                 },
                                 {
                                    "id":"8",
                                    "item":"starts with",
                                    "value":{
                                       "id":"8",
                                       "type":"starts with"
                                    }
                                 },
                                 {
                                    "id":"9",
                                    "item":"ends with",
                                    "value":{
                                       "id":"9",
                                       "type":"ends with"
                                    }
                                 }
                              ]
                           },
                           "prefix":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "suffix":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "wholeNumberLength":{
                              "value":10,
                              "control":"TextBox"
                           },
                           "decimalSize":{
                              "value":2,
                              "control":"TextBox"
                           },
                           "decimalSeparator":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "groupSize":{
                              "value":3,
                              "control":"TextBox"
                           },
                           "groupSeparator":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "index":{
                              "value":false,
                              "control":"CheckBox"
                           }
                        },
                        "policy":{
                           "read":true,
                           "edit":true,
                           "delete":true
                        },
                        "styles":{
                           "fontSize":{
                              "value":"14px"
                           },
                           "fontFamily":{
                              "value":"Arial"
                           },
                           "color":{
                              "value":"#212121"
                           },
                           "left":{
                              "value":10,
                              "hide":true
                           },
                           "top":{
                              "value":50,
                              "hide":true
                           },
                           "width":{
                              "value":"224px",
                              "hide":true
                           },
                           "display":{
                              "value":"flex",
                              "hide":true
                           },
                           "height":{
                              "value":"25px",
                              "hide":true
                           },
                           "visibility":{
                              "value":"visible"
                           },
                           "borderLeft":{
                              "value":"1px solid #cccccc"
                           },
                           "borderTop":{
                              "value":"1px solid #cccccc"
                           },
                           "borderTopLeftRadius":{
                              "value":"2px"
                           },
                           "borderTopRightRadius":{
                              "value":"2px"
                           },
                           "borderRight":{
                              "value":"1px solid #cccccc"
                           },
                           "borderBottom":{
                              "value":"1px solid #cccccc"
                           },
                           "borderBottomLeftRadius":{
                              "value":"2px"
                           },
                           "borderBottomRightRadius":{
                              "value":"2px"
                           },
                           "background":{
                              "value":"white"
                           },
                           "boxSizing":{
                              "value":"border-box",
                              "hide":true
                           },
                           "textAlign":{
                              "value":"left"
                           },
                           "resize":{
                              "value":"both",
                              "hide":true
                           },
                           "overflow":{
                              "value":"auto",
                              "hide":true
                           }
                        },
                        "globalId":"f622ca07-b19c-420f-b570-ab94b41a4092",
                        "parentId":[
                           8,
                           5,
                           1
                        ],
                        "parentGlobalId":[
                           "8af4353a-b9c3-41c9-a7e3-ef91e8112d40",
                           "55bcafe9-3c5d-49d8-a7a0-f6504879f17e",
                           "4b0bd589-f5a3-4360-9dba-9ecec09b8ea1"
                        ],
                        "headerId":27
                     }
                  ],
                  "policy":{
                     "read":true,
                     "edit":true,
                     "delete":true
                  },
                  "styles":{
                     "fontSize":{
                        "value":"14px"
                     },
                     "fontFamily":{
                        "value":"Arial"
                     },
                     "color":{
                        "value":"#cccccc"
                     },
                     "backgroundColor":{
                        "value":"white"
                     },
                     "height":{
                        "value":"30px",
                        "hide":true
                     },
                     "width":{
                        "value":"100%",
                        "hide":true
                     },
                     "display":{
                        "value":"flex",
                        "hide":true
                     },
                     "position":{
                        "value":"relative",
                        "hide":true
                     },
                     "boxSizing":{
                        "value":"border-box",
                        "hide":true
                     },
                     "overflow":{
                        "value":"hidden",
                        "hide":true
                     },
                     "border":{
                        "value":"1px solid #cccccc"
                     }
                  },
                  "left":{
                     "value":5
                  },
                  "top":{
                     "value":59
                  },
                  "globalId":"8af4353a-b9c3-41c9-a7e3-ef91e8112d40",
                  "parentId":[
                     5,
                     1
                  ],
                  "parentGlobalId":[
                     "55bcafe9-3c5d-49d8-a7a0-f6504879f17e",
                     "4b0bd589-f5a3-4360-9dba-9ecec09b8ea1"
                  ]
               },
               {
                  "id":9,
                  "order":5,
                  "currentMaxId":0,
                  "type":"Rows",
                  "properties":{
                     "name":{
                        "value":"Rows9",
                        "control":"TextBox"
                     },
                     "text":{
                        "value":"Rows",
                        "control":"TextBox"
                     }
                  },
                  "metaData":[
                     {
                        "id":12,
                        "order":2,
                        "type":"TextBox",
                        "properties":{
                           "name":{
                              "value":"TextBox12",
                              "control":"TextBox"
                           },
                           "field":{
                              "value":"TextBox",
                              "control":"TextBox"
                           },
                           "text":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "actions":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "readOnly":{
                              "value":false,
                              "control":"CheckBox"
                           },
                           "placeholder":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "toolTip":{
                              "value":false,
                              "control":"CheckBox"
                           },
                           "toolTipText":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "maxLength":{
                              "value":200,
                              "control":"TextBox"
                           },
                           "type":{
                              "value":"String",
                              "control":"ListBox",
                              "values":[
                                 {
                                    "id":"0",
                                    "item":"String",
                                    "value":"String"
                                 },
                                 {
                                    "id":"1",
                                    "item":"Integer",
                                    "value":"Integer"
                                 },
                                 {
                                    "id":"2",
                                    "item":"Decimal",
                                    "value":"Decimal"
                                 }
                              ]
                           },
                           "masks":{
                              "value":"",
                              "control":"TextBox",
                              "maskValue":""
                           },
                           "validations":{
                              "value":"",
                              "control":"ListBoxCheckBox",
                              "selectedValues":[
                                 
                              ],
                              "values":[
                                 {
                                    "id":"1",
                                    "item":"REQUIRE",
                                    "value":{
                                       "id":"1",
                                       "type":"REQUIRE",
                                       "events":[
                                          "onBlur",
                                          "onSubmit"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"2",
                                    "item":"NUMBER",
                                    "value":{
                                       "id":"2",
                                       "type":"NUMBER",
                                       "events":[
                                          "onChange",
                                          "onkeyPress"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"3",
                                    "item":"EMAIL",
                                    "value":{
                                       "id":"3",
                                       "type":"EMAIL",
                                       "events":[
                                          "onBlur"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"4",
                                    "item":"UNIQUE",
                                    "value":{
                                       "id":"4",
                                       "type":"UNIQUE",
                                       "events":[
                                          "onBlur"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"5",
                                    "item":"NOSPACE",
                                    "value":{
                                       "id":"5",
                                       "type":"NOSPACE",
                                       "events":[
                                          "onkeyPress"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"6",
                                    "item":"NOSPECIALCHAR",
                                    "value":{
                                       "id":"6",
                                       "type":"NOSPECIALCHAR",
                                       "events":[
                                          "onkeyPress"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"7",
                                    "item":"PATTERN",
                                    "value":{
                                       "id":"7",
                                       "type":"PATTERN",
                                       "events":[
                                          "onBlur"
                                       ]
                                    }
                                 }
                              ]
                           },
                           "operators":{
                              "value":"",
                              "control":"ListBoxCheckBox",
                              "selectedValues":[
                                 
                              ],
                              "values":[
                                 {
                                    "id":"1",
                                    "item":"equal",
                                    "value":{
                                       "id":"1",
                                       "type":"equal"
                                    }
                                 },
                                 {
                                    "id":"2",
                                    "item":"not equal",
                                    "value":{
                                       "id":"2",
                                       "type":"not equal"
                                    }
                                 },
                                 {
                                    "id":"3",
                                    "item":"greater",
                                    "value":{
                                       "id":"3",
                                       "type":"greater"
                                    }
                                 },
                                 {
                                    "id":"4",
                                    "item":"greater & equal",
                                    "value":{
                                       "id":"4",
                                       "type":"greater & equal"
                                    }
                                 },
                                 {
                                    "id":"5",
                                    "item":"lower",
                                    "value":{
                                       "id":"5",
                                       "type":"lower"
                                    }
                                 },
                                 {
                                    "id":"6",
                                    "item":"lower & equal",
                                    "value":{
                                       "id":"6",
                                       "type":"lower & equal"
                                    }
                                 },
                                 {
                                    "id":"7",
                                    "item":"contains",
                                    "value":{
                                       "id":"7",
                                       "type":"contains"
                                    }
                                 },
                                 {
                                    "id":"8",
                                    "item":"starts with",
                                    "value":{
                                       "id":"8",
                                       "type":"starts with"
                                    }
                                 },
                                 {
                                    "id":"9",
                                    "item":"ends with",
                                    "value":{
                                       "id":"9",
                                       "type":"ends with"
                                    }
                                 }
                              ]
                           },
                           "prefix":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "suffix":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "wholeNumberLength":{
                              "value":10,
                              "control":"TextBox"
                           },
                           "decimalSize":{
                              "value":2,
                              "control":"TextBox"
                           },
                           "decimalSeparator":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "groupSize":{
                              "value":3,
                              "control":"TextBox"
                           },
                           "groupSeparator":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "index":{
                              "value":false,
                              "control":"CheckBox"
                           }
                        },
                        "policy":{
                           "read":true,
                           "edit":true,
                           "delete":true
                        },
                        "styles":{
                           "fontSize":{
                              "value":"14px"
                           },
                           "fontFamily":{
                              "value":"Arial"
                           },
                           "color":{
                              "value":"#212121"
                           },
                           "left":{
                              "value":10,
                              "hide":true
                           },
                           "top":{
                              "value":50,
                              "hide":true
                           },
                           "width":{
                              "value":"48px",
                              "hide":true
                           },
                           "display":{
                              "value":"flex",
                              "hide":true
                           },
                           "height":{
                              "value":"25px",
                              "hide":true
                           },
                           "visibility":{
                              "value":"visible"
                           },
                           "borderLeft":{
                              "value":"1px solid #cccccc"
                           },
                           "borderTop":{
                              "value":"1px solid #cccccc"
                           },
                           "borderTopLeftRadius":{
                              "value":"2px"
                           },
                           "borderTopRightRadius":{
                              "value":"2px"
                           },
                           "borderRight":{
                              "value":"1px solid #cccccc"
                           },
                           "borderBottom":{
                              "value":"1px solid #cccccc"
                           },
                           "borderBottomLeftRadius":{
                              "value":"2px"
                           },
                           "borderBottomRightRadius":{
                              "value":"2px"
                           },
                           "background":{
                              "value":"white"
                           },
                           "boxSizing":{
                              "value":"border-box",
                              "hide":true
                           },
                           "textAlign":{
                              "value":"left"
                           },
                           "resize":{
                              "value":"both",
                              "hide":true
                           },
                           "overflow":{
                              "value":"auto",
                              "hide":true
                           }
                        },
                        "globalId":"6c081bad-e9b7-43b1-be4b-9564f5b2157d",
                        "parentId":[
                           9,
                           5,
                           1
                        ],
                        "parentGlobalId":[
                           "c017c22f-3fc1-4b80-a3fe-2189b475b8eb",
                           "55bcafe9-3c5d-49d8-a7a0-f6504879f17e",
                           "4b0bd589-f5a3-4360-9dba-9ecec09b8ea1"
                        ],
                        "headerId":11
                     },
                     {
                        "id":16,
                        "order":2,
                        "type":"TextBox",
                        "properties":{
                           "name":{
                              "value":"GFistName",
                              "control":"TextBox"
                           },
                           "field":{
                              "value":"FirstName",
                              "control":"TextBox"
                           },
                           "text":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "actions":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "readOnly":{
                              "value":true,
                              "control":"CheckBox"
                           },
                           "placeholder":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "toolTip":{
                              "value":false,
                              "control":"CheckBox"
                           },
                           "toolTipText":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "maxLength":{
                              "value":200,
                              "control":"TextBox"
                           },
                           "type":{
                              "value":"String",
                              "control":"ListBox",
                              "values":[
                                 {
                                    "id":"0",
                                    "item":"String",
                                    "value":"String"
                                 },
                                 {
                                    "id":"1",
                                    "item":"Integer",
                                    "value":"Integer"
                                 },
                                 {
                                    "id":"2",
                                    "item":"Decimal",
                                    "value":"Decimal"
                                 }
                              ]
                           },
                           "masks":{
                              "value":"",
                              "control":"TextBox",
                              "maskValue":""
                           },
                           "validations":{
                              "value":"",
                              "control":"ListBoxCheckBox",
                              "selectedValues":[
                                 
                              ],
                              "values":[
                                 {
                                    "id":"1",
                                    "item":"REQUIRE",
                                    "value":{
                                       "id":"1",
                                       "type":"REQUIRE",
                                       "events":[
                                          "onBlur",
                                          "onSubmit"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"2",
                                    "item":"NUMBER",
                                    "value":{
                                       "id":"2",
                                       "type":"NUMBER",
                                       "events":[
                                          "onChange",
                                          "onkeyPress"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"3",
                                    "item":"EMAIL",
                                    "value":{
                                       "id":"3",
                                       "type":"EMAIL",
                                       "events":[
                                          "onBlur"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"4",
                                    "item":"UNIQUE",
                                    "value":{
                                       "id":"4",
                                       "type":"UNIQUE",
                                       "events":[
                                          "onBlur"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"5",
                                    "item":"NOSPACE",
                                    "value":{
                                       "id":"5",
                                       "type":"NOSPACE",
                                       "events":[
                                          "onkeyPress"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"6",
                                    "item":"NOSPECIALCHAR",
                                    "value":{
                                       "id":"6",
                                       "type":"NOSPECIALCHAR",
                                       "events":[
                                          "onkeyPress"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"7",
                                    "item":"PATTERN",
                                    "value":{
                                       "id":"7",
                                       "type":"PATTERN",
                                       "events":[
                                          "onBlur"
                                       ]
                                    }
                                 }
                              ]
                           },
                           "operators":{
                              "value":"",
                              "control":"ListBoxCheckBox",
                              "selectedValues":[
                                 
                              ],
                              "values":[
                                 {
                                    "id":"1",
                                    "item":"equal",
                                    "value":{
                                       "id":"1",
                                       "type":"equal"
                                    }
                                 },
                                 {
                                    "id":"2",
                                    "item":"not equal",
                                    "value":{
                                       "id":"2",
                                       "type":"not equal"
                                    }
                                 },
                                 {
                                    "id":"3",
                                    "item":"greater",
                                    "value":{
                                       "id":"3",
                                       "type":"greater"
                                    }
                                 },
                                 {
                                    "id":"4",
                                    "item":"greater & equal",
                                    "value":{
                                       "id":"4",
                                       "type":"greater & equal"
                                    }
                                 },
                                 {
                                    "id":"5",
                                    "item":"lower",
                                    "value":{
                                       "id":"5",
                                       "type":"lower"
                                    }
                                 },
                                 {
                                    "id":"6",
                                    "item":"lower & equal",
                                    "value":{
                                       "id":"6",
                                       "type":"lower & equal"
                                    }
                                 },
                                 {
                                    "id":"7",
                                    "item":"contains",
                                    "value":{
                                       "id":"7",
                                       "type":"contains"
                                    }
                                 },
                                 {
                                    "id":"8",
                                    "item":"starts with",
                                    "value":{
                                       "id":"8",
                                       "type":"starts with"
                                    }
                                 },
                                 {
                                    "id":"9",
                                    "item":"ends with",
                                    "value":{
                                       "id":"9",
                                       "type":"ends with"
                                    }
                                 }
                              ]
                           },
                           "prefix":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "suffix":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "wholeNumberLength":{
                              "value":10,
                              "control":"TextBox"
                           },
                           "decimalSize":{
                              "value":2,
                              "control":"TextBox"
                           },
                           "decimalSeparator":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "groupSize":{
                              "value":3,
                              "control":"TextBox"
                           },
                           "groupSeparator":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "index":{
                              "value":false,
                              "control":"CheckBox"
                           }
                        },
                        "policy":{
                           "read":true,
                           "edit":true,
                           "delete":true
                        },
                        "styles":{
                           "fontSize":{
                              "value":"14px"
                           },
                           "fontFamily":{
                              "value":"Arial"
                           },
                           "color":{
                              "value":"#212121"
                           },
                           "left":{
                              "value":10,
                              "hide":true
                           },
                           "top":{
                              "value":50,
                              "hide":true
                           },
                           "width":{
                              "value":"235px",
                              "hide":true
                           },
                           "display":{
                              "value":"flex",
                              "hide":true
                           },
                           "height":{
                              "value":"25px",
                              "hide":true
                           },
                           "visibility":{
                              "value":"visible"
                           },
                           "borderLeft":{
                              "value":"1px solid #cccccc"
                           },
                           "borderTop":{
                              "value":"1px solid #cccccc"
                           },
                           "borderTopLeftRadius":{
                              "value":"2px"
                           },
                           "borderTopRightRadius":{
                              "value":"2px"
                           },
                           "borderRight":{
                              "value":"1px solid #cccccc"
                           },
                           "borderBottom":{
                              "value":"1px solid #cccccc"
                           },
                           "borderBottomLeftRadius":{
                              "value":"2px"
                           },
                           "borderBottomRightRadius":{
                              "value":"2px"
                           },
                           "background":{
                              "value":"white"
                           },
                           "boxSizing":{
                              "value":"border-box",
                              "hide":true
                           },
                           "textAlign":{
                              "value":"left"
                           },
                           "resize":{
                              "value":"both",
                              "hide":true
                           },
                           "overflow":{
                              "value":"auto",
                              "hide":true
                           }
                        },
                        "globalId":"0749f752-a904-49fc-87ef-499d0b1071b4",
                        "parentId":[
                           9,
                           5,
                           1
                        ],
                        "parentGlobalId":[
                           "c017c22f-3fc1-4b80-a3fe-2189b475b8eb",
                           "55bcafe9-3c5d-49d8-a7a0-f6504879f17e",
                           "4b0bd589-f5a3-4360-9dba-9ecec09b8ea1"
                        ],
                        "headerId":15
                     },
                     {
                        "id":20,
                        "order":2,
                        "type":"TextBox",
                        "properties":{
                           "name":{
                              "value":"GLastName",
                              "control":"TextBox"
                           },
                           "field":{
                              "value":"LastName",
                              "control":"TextBox"
                           },
                           "text":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "actions":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "readOnly":{
                              "value":true,
                              "control":"CheckBox"
                           },
                           "placeholder":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "toolTip":{
                              "value":false,
                              "control":"CheckBox"
                           },
                           "toolTipText":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "maxLength":{
                              "value":200,
                              "control":"TextBox"
                           },
                           "type":{
                              "value":"String",
                              "control":"ListBox",
                              "values":[
                                 {
                                    "id":"0",
                                    "item":"String",
                                    "value":"String"
                                 },
                                 {
                                    "id":"1",
                                    "item":"Integer",
                                    "value":"Integer"
                                 },
                                 {
                                    "id":"2",
                                    "item":"Decimal",
                                    "value":"Decimal"
                                 }
                              ]
                           },
                           "masks":{
                              "value":"",
                              "control":"TextBox",
                              "maskValue":""
                           },
                           "validations":{
                              "value":"",
                              "control":"ListBoxCheckBox",
                              "selectedValues":[
                                 
                              ],
                              "values":[
                                 {
                                    "id":"1",
                                    "item":"REQUIRE",
                                    "value":{
                                       "id":"1",
                                       "type":"REQUIRE",
                                       "events":[
                                          "onBlur",
                                          "onSubmit"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"2",
                                    "item":"NUMBER",
                                    "value":{
                                       "id":"2",
                                       "type":"NUMBER",
                                       "events":[
                                          "onChange",
                                          "onkeyPress"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"3",
                                    "item":"EMAIL",
                                    "value":{
                                       "id":"3",
                                       "type":"EMAIL",
                                       "events":[
                                          "onBlur"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"4",
                                    "item":"UNIQUE",
                                    "value":{
                                       "id":"4",
                                       "type":"UNIQUE",
                                       "events":[
                                          "onBlur"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"5",
                                    "item":"NOSPACE",
                                    "value":{
                                       "id":"5",
                                       "type":"NOSPACE",
                                       "events":[
                                          "onkeyPress"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"6",
                                    "item":"NOSPECIALCHAR",
                                    "value":{
                                       "id":"6",
                                       "type":"NOSPECIALCHAR",
                                       "events":[
                                          "onkeyPress"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"7",
                                    "item":"PATTERN",
                                    "value":{
                                       "id":"7",
                                       "type":"PATTERN",
                                       "events":[
                                          "onBlur"
                                       ]
                                    }
                                 }
                              ]
                           },
                           "operators":{
                              "value":"",
                              "control":"ListBoxCheckBox",
                              "selectedValues":[
                                 
                              ],
                              "values":[
                                 {
                                    "id":"1",
                                    "item":"equal",
                                    "value":{
                                       "id":"1",
                                       "type":"equal"
                                    }
                                 },
                                 {
                                    "id":"2",
                                    "item":"not equal",
                                    "value":{
                                       "id":"2",
                                       "type":"not equal"
                                    }
                                 },
                                 {
                                    "id":"3",
                                    "item":"greater",
                                    "value":{
                                       "id":"3",
                                       "type":"greater"
                                    }
                                 },
                                 {
                                    "id":"4",
                                    "item":"greater & equal",
                                    "value":{
                                       "id":"4",
                                       "type":"greater & equal"
                                    }
                                 },
                                 {
                                    "id":"5",
                                    "item":"lower",
                                    "value":{
                                       "id":"5",
                                       "type":"lower"
                                    }
                                 },
                                 {
                                    "id":"6",
                                    "item":"lower & equal",
                                    "value":{
                                       "id":"6",
                                       "type":"lower & equal"
                                    }
                                 },
                                 {
                                    "id":"7",
                                    "item":"contains",
                                    "value":{
                                       "id":"7",
                                       "type":"contains"
                                    }
                                 },
                                 {
                                    "id":"8",
                                    "item":"starts with",
                                    "value":{
                                       "id":"8",
                                       "type":"starts with"
                                    }
                                 },
                                 {
                                    "id":"9",
                                    "item":"ends with",
                                    "value":{
                                       "id":"9",
                                       "type":"ends with"
                                    }
                                 }
                              ]
                           },
                           "prefix":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "suffix":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "wholeNumberLength":{
                              "value":10,
                              "control":"TextBox"
                           },
                           "decimalSize":{
                              "value":2,
                              "control":"TextBox"
                           },
                           "decimalSeparator":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "groupSize":{
                              "value":3,
                              "control":"TextBox"
                           },
                           "groupSeparator":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "index":{
                              "value":false,
                              "control":"CheckBox"
                           }
                        },
                        "policy":{
                           "read":true,
                           "edit":true,
                           "delete":true
                        },
                        "styles":{
                           "fontSize":{
                              "value":"14px"
                           },
                           "fontFamily":{
                              "value":"Arial"
                           },
                           "color":{
                              "value":"#212121"
                           },
                           "left":{
                              "value":10,
                              "hide":true
                           },
                           "top":{
                              "value":50,
                              "hide":true
                           },
                           "width":{
                              "value":"258px",
                              "hide":true
                           },
                           "display":{
                              "value":"flex",
                              "hide":true
                           },
                           "height":{
                              "value":"25px",
                              "hide":true
                           },
                           "visibility":{
                              "value":"visible"
                           },
                           "borderLeft":{
                              "value":"1px solid #cccccc"
                           },
                           "borderTop":{
                              "value":"1px solid #cccccc"
                           },
                           "borderTopLeftRadius":{
                              "value":"2px"
                           },
                           "borderTopRightRadius":{
                              "value":"2px"
                           },
                           "borderRight":{
                              "value":"1px solid #cccccc"
                           },
                           "borderBottom":{
                              "value":"1px solid #cccccc"
                           },
                           "borderBottomLeftRadius":{
                              "value":"2px"
                           },
                           "borderBottomRightRadius":{
                              "value":"2px"
                           },
                           "background":{
                              "value":"white"
                           },
                           "boxSizing":{
                              "value":"border-box",
                              "hide":true
                           },
                           "textAlign":{
                              "value":"left"
                           },
                           "resize":{
                              "value":"both",
                              "hide":true
                           },
                           "overflow":{
                              "value":"auto",
                              "hide":true
                           }
                        },
                        "globalId":"e86e9935-b4ca-434a-852f-4c5b9cceae59",
                        "parentId":[
                           9,
                           5,
                           1
                        ],
                        "parentGlobalId":[
                           "c017c22f-3fc1-4b80-a3fe-2189b475b8eb",
                           "55bcafe9-3c5d-49d8-a7a0-f6504879f17e",
                           "4b0bd589-f5a3-4360-9dba-9ecec09b8ea1"
                        ],
                        "headerId":19
                     },
                     {
                        "id":28,
                        "order":2,
                        "type":"TextBox",
                        "properties":{
                           "name":{
                              "value":"GEmail",
                              "control":"TextBox"
                           },
                           "field":{
                              "value":"Email",
                              "control":"TextBox"
                           },
                           "text":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "actions":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "readOnly":{
                              "value":true,
                              "control":"CheckBox"
                           },
                           "placeholder":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "toolTip":{
                              "value":false,
                              "control":"CheckBox"
                           },
                           "toolTipText":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "maxLength":{
                              "value":200,
                              "control":"TextBox"
                           },
                           "type":{
                              "value":"String",
                              "control":"ListBox",
                              "values":[
                                 {
                                    "id":"0",
                                    "item":"String",
                                    "value":"String"
                                 },
                                 {
                                    "id":"1",
                                    "item":"Integer",
                                    "value":"Integer"
                                 },
                                 {
                                    "id":"2",
                                    "item":"Decimal",
                                    "value":"Decimal"
                                 }
                              ]
                           },
                           "masks":{
                              "value":"",
                              "control":"TextBox",
                              "maskValue":""
                           },
                           "validations":{
                              "value":"",
                              "control":"ListBoxCheckBox",
                              "selectedValues":[
                                 
                              ],
                              "values":[
                                 {
                                    "id":"1",
                                    "item":"REQUIRE",
                                    "value":{
                                       "id":"1",
                                       "type":"REQUIRE",
                                       "events":[
                                          "onBlur",
                                          "onSubmit"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"2",
                                    "item":"NUMBER",
                                    "value":{
                                       "id":"2",
                                       "type":"NUMBER",
                                       "events":[
                                          "onChange",
                                          "onkeyPress"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"3",
                                    "item":"EMAIL",
                                    "value":{
                                       "id":"3",
                                       "type":"EMAIL",
                                       "events":[
                                          "onBlur"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"4",
                                    "item":"UNIQUE",
                                    "value":{
                                       "id":"4",
                                       "type":"UNIQUE",
                                       "events":[
                                          "onBlur"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"5",
                                    "item":"NOSPACE",
                                    "value":{
                                       "id":"5",
                                       "type":"NOSPACE",
                                       "events":[
                                          "onkeyPress"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"6",
                                    "item":"NOSPECIALCHAR",
                                    "value":{
                                       "id":"6",
                                       "type":"NOSPECIALCHAR",
                                       "events":[
                                          "onkeyPress"
                                       ]
                                    }
                                 },
                                 {
                                    "id":"7",
                                    "item":"PATTERN",
                                    "value":{
                                       "id":"7",
                                       "type":"PATTERN",
                                       "events":[
                                          "onBlur"
                                       ]
                                    }
                                 }
                              ]
                           },
                           "operators":{
                              "value":"",
                              "control":"ListBoxCheckBox",
                              "selectedValues":[
                                 
                              ],
                              "values":[
                                 {
                                    "id":"1",
                                    "item":"equal",
                                    "value":{
                                       "id":"1",
                                       "type":"equal"
                                    }
                                 },
                                 {
                                    "id":"2",
                                    "item":"not equal",
                                    "value":{
                                       "id":"2",
                                       "type":"not equal"
                                    }
                                 },
                                 {
                                    "id":"3",
                                    "item":"greater",
                                    "value":{
                                       "id":"3",
                                       "type":"greater"
                                    }
                                 },
                                 {
                                    "id":"4",
                                    "item":"greater & equal",
                                    "value":{
                                       "id":"4",
                                       "type":"greater & equal"
                                    }
                                 },
                                 {
                                    "id":"5",
                                    "item":"lower",
                                    "value":{
                                       "id":"5",
                                       "type":"lower"
                                    }
                                 },
                                 {
                                    "id":"6",
                                    "item":"lower & equal",
                                    "value":{
                                       "id":"6",
                                       "type":"lower & equal"
                                    }
                                 },
                                 {
                                    "id":"7",
                                    "item":"contains",
                                    "value":{
                                       "id":"7",
                                       "type":"contains"
                                    }
                                 },
                                 {
                                    "id":"8",
                                    "item":"starts with",
                                    "value":{
                                       "id":"8",
                                       "type":"starts with"
                                    }
                                 },
                                 {
                                    "id":"9",
                                    "item":"ends with",
                                    "value":{
                                       "id":"9",
                                       "type":"ends with"
                                    }
                                 }
                              ]
                           },
                           "prefix":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "suffix":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "wholeNumberLength":{
                              "value":10,
                              "control":"TextBox"
                           },
                           "decimalSize":{
                              "value":2,
                              "control":"TextBox"
                           },
                           "decimalSeparator":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "groupSize":{
                              "value":3,
                              "control":"TextBox"
                           },
                           "groupSeparator":{
                              "value":"",
                              "control":"TextBox"
                           },
                           "index":{
                              "value":false,
                              "control":"CheckBox"
                           }
                        },
                        "policy":{
                           "read":true,
                           "edit":true,
                           "delete":true
                        },
                        "styles":{
                           "fontSize":{
                              "value":"14px"
                           },
                           "fontFamily":{
                              "value":"Arial"
                           },
                           "color":{
                              "value":"#212121"
                           },
                           "left":{
                              "value":10,
                              "hide":true
                           },
                           "top":{
                              "value":50,
                              "hide":true
                           },
                           "width":{
                              "value":"224px",
                              "hide":true
                           },
                           "display":{
                              "value":"flex",
                              "hide":true
                           },
                           "height":{
                              "value":"25px",
                              "hide":true
                           },
                           "visibility":{
                              "value":"visible"
                           },
                           "borderLeft":{
                              "value":"1px solid #cccccc"
                           },
                           "borderTop":{
                              "value":"1px solid #cccccc"
                           },
                           "borderTopLeftRadius":{
                              "value":"2px"
                           },
                           "borderTopRightRadius":{
                              "value":"2px"
                           },
                           "borderRight":{
                              "value":"1px solid #cccccc"
                           },
                           "borderBottom":{
                              "value":"1px solid #cccccc"
                           },
                           "borderBottomLeftRadius":{
                              "value":"2px"
                           },
                           "borderBottomRightRadius":{
                              "value":"2px"
                           },
                           "background":{
                              "value":"white"
                           },
                           "boxSizing":{
                              "value":"border-box",
                              "hide":true
                           },
                           "textAlign":{
                              "value":"left"
                           },
                           "resize":{
                              "value":"both",
                              "hide":true
                           },
                           "overflow":{
                              "value":"auto",
                              "hide":true
                           }
                        },
                        "globalId":"99f5450e-24be-4693-9eaf-ef7ba77adbac",
                        "parentId":[
                           9,
                           5,
                           1
                        ],
                        "parentGlobalId":[
                           "c017c22f-3fc1-4b80-a3fe-2189b475b8eb",
                           "55bcafe9-3c5d-49d8-a7a0-f6504879f17e",
                           "4b0bd589-f5a3-4360-9dba-9ecec09b8ea1"
                        ],
                        "headerId":27
                     }
                  ],
                  "policy":{
                     "read":true,
                     "edit":true,
                     "delete":true
                  },
                  "styles":{
                     "fontSize":{
                        "value":"14px"
                     },
                     "fontFamily":{
                        "value":"Arial"
                     },
                     "color":{
                        "value":"#cccccc"
                     },
                     "backgroundColor":{
                        "value":"white"
                     },
                     "height":{
                        "value":"30px",
                        "hide":true
                     },
                     "width":{
                        "value":"100%",
                        "hide":true
                     },
                     "display":{
                        "value":"flex",
                        "hide":true
                     },
                     "position":{
                        "value":"relative",
                        "hide":true
                     },
                     "boxSizing":{
                        "value":"border-box",
                        "hide":true
                     },
                     "overflow":{
                        "value":"hidden",
                        "hide":true
                     },
                     "border":{
                        "value":"1px solid #cccccc"
                     }
                  },
                  "left":{
                     "value":5
                  },
                  "top":{
                     "value":59
                  },
                  "globalId":"c017c22f-3fc1-4b80-a3fe-2189b475b8eb",
                  "parentId":[
                     5,
                     1
                  ],
                  "parentGlobalId":[
                     "55bcafe9-3c5d-49d8-a7a0-f6504879f17e",
                     "4b0bd589-f5a3-4360-9dba-9ecec09b8ea1"
                  ]
               }
            ],
            "policy":{
               "read":true,
               "edit":true,
               "delete":true
            },
            "styles":{
               "fontSize":{
                  "value":"14px"
               },
               "fontFamily":{
                  "value":"Arial"
               },
               "color":{
                  "value":"#cccccc"
               },
               "width":{
                  "value":"800px",
                  "hide":true
               },
               "height":{
                  "value":"390px",
                  "hide":true
               },
               "resize":{
                  "value":"both",
                  "hide":true
               },
               "position":{
                  "value":"absolute",
                  "hide":true
               },
               "boxSizing":{
                  "value":"border-box",
                  "hide":true
               },
               "zIndex":{
                  "value":1,
                  "hide":true
               },
               "backgroundColor":{
                  "value":"white"
               },
               "border":{
                  "value":"1px solid #cccccc"
               },
               "overflow":{
                  "value":"auto",
                  "hide":true
               },
               "left":{
                  "value":9,
                  "hide":true
               },
               "top":{
                  "value":59,
                  "hide":true
               }
            },
            "excludesDropTypes":[
               "Label",
               "DataGrid",
               "Line",
               "Radio",
               "GroupBox",
               "Button",
               "RichTextBox",
               "TreeBox",
               "TextEditor"
            ],
            "parentId":[
               1
            ],
            "left":{
               "value":5
            },
            "top":{
               "value":59
            },
            "globalId":"55bcafe9-3c5d-49d8-a7a0-f6504879f17e",
            "parentGlobalId":[
               "4b0bd589-f5a3-4360-9dba-9ecec09b8ea1"
            ]
         }
      ],
      "styles":{
         "color":{
            "value":"#212121"
         },
         "backgroundColor":{
            "value":"white"
         },
         "width":{
            "value":"821px",
            "hide":true
         },
         "height":{
            "value":"470px",
            "hide":true
         },
         "position":{
            "value":"relative",
            "hide":true
         },
         "border":{
            "value":"none"
         },
         "resize":{
            "value":"auto",
            "hide":true
         }
      },
      "globalId":"4b0bd589-f5a3-4360-9dba-9ecec09b8ea1"
   }
  ],

  apiSchemas:[{
    "globalId":"12d35cfc-e484-4148-8548-cc8f294b75c3",
    "id":"12d35cfc-e484-4148-8548-cc8f294b75c3",
    "item":"LoadUser",
    "type":"Api",
    "isExpanded":false,
    "isChecked":false,
    "childs":[
       {
          "id":"12d35cfc-e484-4148-8548-cc8f294b75c3_0",
          "parentId":"12d35cfc-e484-4148-8548-cc8f294b75c3",
          "item":"profil",
          "type":"string",
          "childs":[
             
          ]
       },
       {
          "id":"12d35cfc-e484-4148-8548-cc8f294b75c3_1",
          "parentId":"12d35cfc-e484-4148-8548-cc8f294b75c3",
          "item":"user",
          "type":"object",
          "childs":[
             {
                "id":"12d35cfc-e484-4148-8548-cc8f294b75c3_1_0",
                "parentId":"12d35cfc-e484-4148-8548-cc8f294b75c3_1",
                "item":"lastName",
                "type":"string",
                "childs":[
                   
                ]
             },
             {
                "id":"12d35cfc-e484-4148-8548-cc8f294b75c3_1_1",
                "parentId":"12d35cfc-e484-4148-8548-cc8f294b75c3_1",
                "item":"firstName",
                "type":"string",
                "childs":[
                   
                ]
             },
             {
                "id":"12d35cfc-e484-4148-8548-cc8f294b75c3_1_2",
                "parentId":"12d35cfc-e484-4148-8548-cc8f294b75c3_1",
                "item":"resetPassword",
                "type":"boolean",
                "childs":[
                   
                ]
             },
             {
                "id":"12d35cfc-e484-4148-8548-cc8f294b75c3_1_3",
                "parentId":"12d35cfc-e484-4148-8548-cc8f294b75c3_1",
                "item":"password",
                "type":"string",
                "childs":[
                   
                ]
             },
             {
                "id":"12d35cfc-e484-4148-8548-cc8f294b75c3_1_4",
                "parentId":"12d35cfc-e484-4148-8548-cc8f294b75c3_1",
                "item":"created_at",
                "type":"string",
                "childs":[
                   
                ]
             },
             {
                "id":"12d35cfc-e484-4148-8548-cc8f294b75c3_1_5",
                "parentId":"12d35cfc-e484-4148-8548-cc8f294b75c3_1",
                "item":"siteName",
                "type":"string",
                "childs":[
                   
                ]
             },
             {
                "id":"12d35cfc-e484-4148-8548-cc8f294b75c3_1_6",
                "parentId":"12d35cfc-e484-4148-8548-cc8f294b75c3_1",
                "item":"confirmed",
                "type":"boolean",
                "childs":[
                   
                ]
             },
             {
                "id":"12d35cfc-e484-4148-8548-cc8f294b75c3_1_7",
                "parentId":"12d35cfc-e484-4148-8548-cc8f294b75c3_1",
                "item":"delete",
                "type":"boolean",
                "childs":[
                   
                ]
             },
             {
                "id":"12d35cfc-e484-4148-8548-cc8f294b75c3_1_8",
                "parentId":"12d35cfc-e484-4148-8548-cc8f294b75c3_1",
                "item":"email",
                "type":"string",
                "childs":[
                   
                ]
             },
             {
                "id":"12d35cfc-e484-4148-8548-cc8f294b75c3_1_9",
                "parentId":"12d35cfc-e484-4148-8548-cc8f294b75c3_1",
                "item":"nTry",
                "type":"number",
                "childs":[
                   
                ]
             }
          ]
       }
    ]
 }],
 currentMetaData:{id:0, maxId:0,  isSealed:false}


}
  const  [user, setUser] = useState({ 
    id: uuid.v4(),
    firstName : "",
    lastName : "",
    email : "",
    password : Math.floor(1000 + Math.random() * 9000),
    resetPassword : true,
    errors:[],
    loading:false,
    canEdit:false,
    organigramId : new URLSearchParams(useLocation().search).get("organigramId"),
    profilGlobalId : new URLSearchParams(useLocation().search).get("profilGlobalId"),
    isEqual:false,
    isUpdate:false
 })
 
  const isEqual =() => {
    const currentFormData = globalState.state.formData.data
    
    
    return !currentFormData.data  || (user.firstName == currentFormData.data.Form.FirstName && user.lastName == currentFormData.data.Form.LastName && user.email == currentFormData.data.Form.Email)
   };
    
  const getSeparator = () => {
    return <div style={{  height: "17px", margin:"7px 10px 0px 10px",  borderRight:"2px solid rgb(223, 221, 221)" }} /> 
  }

  const refreshData =(result, currentFormData = undefined) => {
   var updatedFormData = currentFormData ? currentFormData : JSON.parse(JSON.stringify(globalState.state.formData));
   if (!updatedFormData.apiData) 
      updatedFormData.apiData = []
   else
      updatedFormData.apiData = updatedFormData.apiData.filter(item => item.globalId != formData.apiSchemas[0].globalId)
   updatedFormData.apiData.push({globalId:formData.apiSchemas[0].globalId, id:formData.apiSchemas[0].id,  data:result})
   dispatch({
     type: "UPDATE_FORM_WITOUT_HISTORIQUE",
     payload: updatedFormData
   });  };
   

  const onCreate = () => {
  
    var userData = JSON.parse(JSON.stringify(user));
    
    if (globalState.state.formData.errors.length == 0 && !user.isEqual && !user.loading) {
      setUser({...userData, loading:true })
      const data = globalState.state.formData.data.data
      axiosOperation({method:"POST"
        , url: "https://flex-services.onrender.com/profilUser/"
        , body:{profilGlobalId:user.profilGlobalId, isUpdate:user.isUpdate,password: "" + user.password + "",companyId:globalState.state.company.id
                ,email:data.Form.Email,  firstName:data.Form.FirstName, lastName:data.Form.LastName
                , resetPassword:true
                , id:user.id, siteName:globalState.state.company.siteName}
        }).then(response => 
          { 
            if(response.managedError) {
              const result = response.result.data
              setUser({...userData,email:data.Form.Email,  firstName:data.Form.FirstName, lastName:data.Form.LastName, 
                isEqual:true,
                canEdit:true,
                resetPassword:true,
                log:result.log && {type:result.log.type, text:result.log.text, style:result.log.style, activeResendEmail:result.activeReSendEmail}})

              if (!result.log)
               refreshData(result)

            }
            else {
              setUser({...userData, log:{text:response.text, style:{fontSize:"12px", color:"rgb(206, 17, 38"}, activeResendEmail:undefined}})
            }
          })
      
    }
    //else 
     // setUser(userData);
  }
   
  const onResetPassword = () => {
  
   var userData = JSON.parse(JSON.stringify(user));
  
   if (globalState.state.formData.errors.length == 0 && user.isEqual && !user.loading) {
   
     setUser({...userData, loading:true })
     
     axiosOperation({method:"POST"
       , url: "https://flex-services.onrender.com/profilUser/"
       , body:{profilGlobalId:user.profilGlobalId, resetPassword:true,password: "" + Math.floor(1000 + Math.random() * 9000) + ""
       ,firstName:user.firstName,isUpdate:user.isUpdate,email:user.email, siteName:globalState.state.company.siteName}
       }).then(response => 
         { 
           if(!response.managedError) {
               setUser({...userData, loading:false, log:{text:response.text, style:{fontSize:"12px", color:"rgb(206, 17, 38"}, activeResendEmail:undefined}})
           } else setUser({...userData, loading:false })
         })
     
   }
   //else 
    // setUser(userData);
 }
  
  const onSelectProfil = (itemSelected, initialFormData=undefined) => {
   
    var userData = JSON.parse(JSON.stringify(user));
    setUser({...userData, loading:true })
    axiosOperation({method:"GET"
      , url: "https://flex-services.onrender.com/profilUser/?id="+ itemSelected.id
      , body: {confirmed:true, nTry:0}
      }).then(response => 
        { 
          
         if(response.managedError) {
            
            const result = response.result.data
            if (result[0]) {
              
               //refreshData(result)
               var updatedFormData = initialFormData ? initialFormData :JSON.parse(JSON.stringify(globalState.state.formData));
               const emptyValue = ""
               setCurrentRowData(updatedFormData, emptyValue)
               updatedFormData.currentRow = undefined
               setUser({...user, profilGlobalId:itemSelected.id, showDelete:false, loading:false, canEdit:false
                  ,firstName:emptyValue,lastName:emptyValue, email:emptyValue, isUpdate:false,isEqual:true})
         
               refreshData(result, updatedFormData)
              
            } else setUser({...user, loading:false, profilGlobalId:itemSelected.id})
         } else setUser({...user, loading:false, profilGlobalId:itemSelected.id})
       
          
        })
    
  }

  const onAdd = () => {
   var updatedFormData = JSON.parse(JSON.stringify(globalState.state.formData));
   const value=""
   setCurrentRowData(updatedFormData, value)
   updatedFormData.currentRow = undefined
   dispatch({
      type: "UPDATE_FORM_WITOUT_HISTORIQUE",
      payload: updatedFormData,
    });
    
   setUser({...user, canEdit:false,firstName:value,lastName:value, email:value, isUpdate:false})
  
  }

  const onDelete = () => {
   if (!user.loading) {
      var userData = JSON.parse(JSON.stringify(user));
      setUser({...userData, loading:true })
      axiosOperation({method:"DELETE"
         , url: "https://flex-services.onrender.com/profilUser/"+ user.email + "?profilGlobalId="+ user.profilGlobalId
         , body: {confirmed:true, nTry:0}
      }).then(response => 
       { 
         
        if(response.managedError) {
           
           const result = response.result.data
           if (result[0]) {
            var updatedFormData = JSON.parse(JSON.stringify(globalState.state.formData));
            const emptyValue = ""
            setCurrentRowData(updatedFormData, emptyValue)
            updatedFormData.currentRow = undefined
            setUser({...user, showDelete:false, loading:false, canEdit:false,firstName:emptyValue,lastName:emptyValue, email:emptyValue, isUpdate:false})
      
            refreshData(result, updatedFormData)
             
           }
        } else setUser({...user, showDelete:false,loading:false})
      
         
       })
   }
 }

  const setCurrentRowData = (updatedFormData, value=undefined) => {
  
   var newValue = {}
  
   var currentsTools = [];
   getCurrentsTools(updatedFormData, currentsTools, [firstNameId, lastNameId, emailId]);
   currentsTools.filter(item => {
      switch (item.id) {
         case firstNameId:
            item.properties.text.value = value != undefined ? value : getCurrentRowComponentValue(headerFirstNameId)
            newValue["firstName"] = item.properties.text.value
            break;
         case lastNameId:
            item.properties.text.value = value != undefined  ? value :getCurrentRowComponentValue(headerLastNameId)
            newValue["lastName"] = item.properties.text.value
            break;
         case emailId:
            
            item.properties.text.value = value != undefined  ? value :getCurrentRowComponentValue(headerEmailId)
            newValue["email"] = item.properties.text.value
            break;
      }   
      
   });
   
   updatedFormData.errors = []
   
   return newValue
  };

 const getCurrentRowComponentValue = (id) => {
  
   return globalState.state.formData.currentRow[0].metaData.filter(item => item.headerId == id)[0].properties.text.value
 }
  
  const canSave = () => {
  
   const data = globalState.state.formData.data.data

   var canSave =  data && (data.Form.Email != "" && data.Form.FirstName && data.Form.LastName)
 

    return canSave && globalState.state.formData.errors.length == 0 && !user.isEqual
  }

  useEffect(() => {
    const data =  globalState.state.formData.data.data
    //if (data)
    //  setUser({...user, email:data.Form.Email,  firstName:data.Form.FirstName, lastname:data.Form.LastName,isEqual:isEqual()})
    //else
    
      setUser({...user,isEqual:isEqual()})
  }, [globalState.state.formData.data]);

  useEffect(() => {
   dispatch({
      type: "SET_META_DATA",
      payload: formData
    });
   const initialFormData = {...globalState.state.formData
          , metaData:formData.metaData
          , data: {}
          , apiSchemas : formData.apiSchemas
          , lists:{...globalState.state.formData.lists, currentMaxId:formData.currentMaxId} 
          , metasData: [{...globalState.state.formData.metasData[0],  values:formData.metaData}] 
          , currentMetaData: formData.currentMetaData
         }
   

   
   onSelectProfil(profils.filter(profil => profil.id == user.profilGlobalId)[0], initialFormData)
    
      
  }, []);

  const currentRowId = globalState.state.formData.currentRow && globalState.state.formData.currentRow[0].id
  
  useEffect(() => {
   
   if (currentRowId ) {
      
      var updatedFormData = JSON.parse(JSON.stringify(globalState.state.formData));
      const newValue = setCurrentRowData(updatedFormData)

      dispatch({
         type: "UPDATE_FORM_WITOUT_HISTORIQUE",
         payload: updatedFormData,
      });

      setUser({...user, canEdit:true,firstName:newValue.firstName,lastName:newValue.lastName, email:newValue.email, isUpdate:true})
    
   }
 
  }, [currentRowId]);
 
  
  const profils = globalState.state.step.profils.filter(organigram => organigram.id == user.organigramId)[0]
  .childs.map(profil => {return { id:profil.id, item:profil.item}})

  return (

    <React.Fragment>
    <div style = {{ marginLeft:"auto",  marginRight:"auto",width:"825px"
    , borderRadius: "4px"
    , padding: "20px"
    , marginTop:"20px" , backgroundColor: "white" }}>
      <div style ={{ display:"flex"}}>
         <span style = {{ fontFamily:"sans-serif",fontSize:"18px", fontWeight:"bold"  }} >Settings Users</span>
         <div onClick ={() => onCreate()} style={{paddingTop: "3px", userSelect:"none", marginLeft:"10px", width:"20px"}}>
             { user.loading ? 
            <div style ={{ marginTop:"-2px"}}><SpinnerIcon /> </div>: 
            <SaveCommand actif = { canSave()} height="15px" /> }
         </div> 
      </div>
      <div style = {{ marginBottom:"5px"  }}>
        { user.log && <span style = {user.log.style} >{user.log.text}</span>}
      </div>
      <div style = {{ marginTop:"10px", display:"flex", height: "33px"}}>
        <span style = {{ fontFamily:"Verdana",fontSize:"14px", marginRight:"10px", marginTop:"7px"  }} >Profil:</span>
        <div style = {{ width:"150px"}}>
         <DropDownListNew
            fontSize={"14px"}
            currentData={profils}
            id={"OptionsList"}
            initialValue={profils.filter(profil => profil.id == user.profilGlobalId)[0].item}
            //multiSelection = {true}
            //selectedValues = {[]}
            onDropDownItemClick={(itemSelected) => !user.loading && onSelectProfil(itemSelected)}
             onlyLabel={false}/>
         </div>
        { getSeparator()}
        <div onClick ={() => onAdd()} style ={{ marginTop:"2px", marginRight:"10px"}}>
          <AddCommand className ="hoverGreen" />
        </div>
        {user.canEdit && <div id="DeleteCommand"
          onClick={(e) => setUser({...user, showDelete:true}) } 
          style ={{ marginTop:"2px", marginRight:"10px" }}>
          <CloseCommand className ="hoverRed"/>
        </div>}
        
        {user.canEdit && <input onClick = {() => onResetPassword()}
         style ={{  marginLeft:"auto", marginRight:"15px",fontSize:"12px", height: "25px"
         , padding: "5px", width: "120px", 
         backgroundColor: user.loading || !user.isEqual ? "lightGray" : "#008dff"}} 
            type="button" className="button" value="Reset Password"/>}

         {user.showDelete && <SimpleDialog changeModeRequired ={false} 
              onClickValid ={(e) => onDelete()} onClose = {() => setUser({...user, showDelete:false})}  
              value = "Are you sure ?"
              isLabel = {true}
              parentId = "DeleteCommand" type = "field" operation = "DELETE"/>}     
        
      </div>
      {/*settings.showDiscard && <SimpleDialog changeModeRequired ={false} 
              onClickValid ={(e) => onDiscard(e)} onClose = {() => setSetting({...settings, showDiscard:false})}  
              value = "Are you sure ?"
              isLabel = {true}
        parentId = "InformationDiscardCommand" type = "field" operation = "DISCARD"/>*/}
      <FormSettings isExecutionMode = {true}/>
    </div>
    {/*<div style = {{ marginLeft:"auto",  marginRight:"auto",width:"760px"  }}>
      
    </div>*/}
    </React.Fragment>
  );
};

/*

      <div style = {{ display:"flex" ,marginTop:"10px" ,marginBottom:"10px"  }}>
        
        {isNewRegister && <input id="FistName" type="textBox" placeholder="First Name" value={user.fistName}  
          onChange={(e)=> setUser({...user, fistName:e.target.value})}
          onBlur={(e) => fireOtherEvent(e, {id:"FistName", name:"First Name" }, [{type :"REQUIRE"}])}
          onKeyPress={(e) => fireEventKeyPress(e, {id:"FistName" })}
          style = {{ marginRight:"10px", fontSize:"14px"   }}
          className="input connexionInput" />}
        {isNewRegister && getError("FistName")}
        
        
        {isNewRegister && <input id="LastName" type="textBox" placeholder="Last Name" value={user.lastName} 
          onChange={(e)=> setUser({...user, lastName:e.target.value})}
          onBlur={(e) => fireOtherEvent(e, {id:"LastName", name:"Last Name" }, [{type :"REQUIRE"}])}
          onKeyPress={(e) => fireEventKeyPress(e, {id:"LastName" }, [{type :"REQUIRE"}])}
          style = {{ marginRight:"10px" , fontSize:"14px"  }}
          className="input connexionInput" />}
        { isNewRegister && getError("LastName")}
        
        
        {<input id="Email" type="textBox" placeholder="Email" value={user.email} 
          readOnly={user.log && user.log.activeResendEmail} 
          onChange={(e)=> setUser({...user, email:e.target.value})}
          onBlur={(e) => fireOtherEvent(e, {id:"Email", name:"Email" }, [{type :"REQUIRE"}, {type :"EMAIL"}])}
          onKeyPress={(e) => fireEventKeyPress(e, {id:"Email" })}
          style = {{ fontSize:"14px"   }}
          className="input connexionInput" />}
        {isNewRegister && getError("Email")}      
        
      </div>
      
<div style = {{ textAlign:"center", display:"flex" }}>
        <Link  style = {{ fontFamily:"Verdana", marginRight:"auto", textDecoration: "none"  }}to="/register">
          <span style = {{ fontSize:"12px", color:"#008dff"}} >Forget password?</span>
        </Link>
        <Link style = {{ fontFamily:"Verdana", marginLeft:"auto", textDecoration: "none"  }} to="/register">
          <span style = {{ fontSize:"12px", color:"yellowGreen" }} >Sign In</span>
        </Link>
      </div>
  */


